/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar type represents time data, represented as an ISO-8601 encoded UTC date string. */
  DateTime: { input: any; output: any; }
  /**
   * The `Upload` special type represents a file to be uploaded in the same HTTP request as specified by
   *  [graphql-multipart-request-spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
   */
  Upload: { input: any; output: any; }
};

export type AbstractBooking = {
  __typename?: 'AbstractBooking';
  /**
   *
   *
   */
  displayNetPromoterSurvey: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  reference: Scalars['String']['output'];
};

export type AbstractBookingFrontendView = {
  __typename?: 'AbstractBookingFrontendView';
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  reference: Scalars['String']['output'];
};

export type AbstractMobileServiceProvider = AbstractMobileServiceProviderInterface & AbstractServiceProviderInterface & {
  __typename?: 'AbstractMobileServiceProvider';
  /**
   *
   *
   */
  address?: Maybe<Address>;
  /**
   *
   *
   */
  addressValidated?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  addressValidationDisabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  allMedias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  basePrice?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  canReceiveInquiries: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  city?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityForSlug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityUrl: Scalars['String']['output'];
  /**
   *
   *
   */
  claimType?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  company?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactFirstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactLastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  countOfInquiries: Scalars['Int']['output'];
  /**
   *
   *
   */
  countOfOutboundLinks: Scalars['Int']['output'];
  /**
   *
   *
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  creatorRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  creatorUser?: Maybe<User>;
  /**
   *
   *
   */
  criteriaCategories: Array<CriteriaCategoryType>;
  /**
   *
   *
   */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  defaultMedia?: Maybe<ServiceProviderMedia>;
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  disableInquiry: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  facebook?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  hasRatings: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  hasStoppedService: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  highlights: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  images: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  inquiries?: Maybe<Array<ServiceProviderInquiry>>;
  /**
   *
   *
   */
  inquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  instagram?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  intro?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  isClaimRequestAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isClaimed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isInquiryAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isOwnershipDenied: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  links: Array<Link>;
  /**
   *
   *
   */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  maximumTravelDistance?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  medias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  moderationRequired: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  nearbyCities: Array<City>;
  /**
   *
   *
   */
  nearbyServiceProviders: Array<ServiceProviderSearchResult>;
  /**
   *
   *
   */
  noIndex: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  owner?: Maybe<User>;
  /**
   *
   *
   */
  ownerRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  ownerStatus?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  pinterest?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  placeHolderImage?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  premium: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  premiumUntil?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  priceNiveau?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pricePerHour?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pricePerKilometer?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  published: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  ratings?: Maybe<PorpaginasResult_AbstractRatingInterface>;
  /**
   *
   *
   */
  ratingsAverage?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  ratingsCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  ratingsOverview?: Maybe<ServiceProviderRatingOverview>;
  /**
   *
   *
   */
  recommendationRate?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  recommendationsCount?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  showNearbyServiceProviders: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  showOnlyForAdmin?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  showRaffle: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  state?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  statistics?: Maybe<Array<KeyValueType>>;
  /**
   *
   *
   */
  stoppedServiceAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  street1?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  street2?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  structuredData: Scalars['String']['output'];
  /**
   *
   *
   */
  twitter?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  type: Scalars['String']['output'];
  /**
   *
   *
   */
  unansweredInquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  url?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  verified?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  viewedBy?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  vimeo?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  website?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  youtube?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  zip?: Maybe<Scalars['String']['output']>;
};


export type AbstractMobileServiceProviderCanonicalUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type AbstractMobileServiceProviderCityUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type AbstractMobileServiceProviderNearbyServiceProvidersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AbstractMobileServiceProviderInterface = {
  /**
   *
   *
   */
  address?: Maybe<Address>;
  /**
   *
   *
   */
  addressValidated?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  addressValidationDisabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  allMedias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  basePrice?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  canReceiveInquiries: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  city?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityForSlug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityUrl: Scalars['String']['output'];
  /**
   *
   *
   */
  claimType?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  company?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactFirstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactLastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  countOfInquiries: Scalars['Int']['output'];
  /**
   *
   *
   */
  countOfOutboundLinks: Scalars['Int']['output'];
  /**
   *
   *
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  creatorRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  creatorUser?: Maybe<User>;
  /**
   *
   *
   */
  criteriaCategories: Array<CriteriaCategoryType>;
  /**
   *
   *
   */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  defaultMedia?: Maybe<ServiceProviderMedia>;
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  disableInquiry: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  facebook?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  hasRatings: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  hasStoppedService: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  highlights: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  images: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  inquiries?: Maybe<Array<ServiceProviderInquiry>>;
  /**
   *
   *
   */
  inquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  instagram?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  intro?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  isClaimRequestAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isClaimed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isInquiryAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isOwnershipDenied: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  links: Array<Link>;
  /**
   *
   *
   */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  maximumTravelDistance?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  medias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  moderationRequired: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  nearbyCities: Array<City>;
  /**
   *
   *
   */
  nearbyServiceProviders: Array<ServiceProviderSearchResult>;
  /**
   *
   *
   */
  noIndex: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  owner?: Maybe<User>;
  /**
   *
   *
   */
  ownerRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  ownerStatus?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  pinterest?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  placeHolderImage?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  premium: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  premiumUntil?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  priceNiveau?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pricePerHour?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pricePerKilometer?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  published: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  ratings?: Maybe<PorpaginasResult_AbstractRatingInterface>;
  /**
   *
   *
   */
  ratingsAverage?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  ratingsCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  ratingsOverview?: Maybe<ServiceProviderRatingOverview>;
  /**
   *
   *
   */
  recommendationRate?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  recommendationsCount?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  showNearbyServiceProviders: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  showOnlyForAdmin?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  showRaffle: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  state?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  statistics?: Maybe<Array<KeyValueType>>;
  /**
   *
   *
   */
  stoppedServiceAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  street1?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  street2?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  structuredData: Scalars['String']['output'];
  /**
   *
   *
   */
  twitter?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  type: Scalars['String']['output'];
  /**
   *
   *
   */
  unansweredInquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  url?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  verified?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  viewedBy?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  vimeo?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  website?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  youtube?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  zip?: Maybe<Scalars['String']['output']>;
};


export type AbstractMobileServiceProviderInterfaceCanonicalUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type AbstractMobileServiceProviderInterfaceCityUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type AbstractMobileServiceProviderInterfaceNearbyServiceProvidersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AbstractRating = AbstractRatingInterface & {
  __typename?: 'AbstractRating';
  /**
   *
   *
   */
  allowedToTakePartInRaffle: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  average: Scalars['Float']['output'];
  /**
   *
   *
   */
  bridalTickets?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  event?: Maybe<Event>;
  /**
   *
   *
   */
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  flexibility?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  isArchived: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  overallImpression?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pax?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  price?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pricePerformanceRatio?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  professionalism?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  qualityOfService?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  recommendation?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  responsiveness?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  reviewerIsBridalCouple: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  reviewerRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  reviewerTickets?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  setAverage: AbstractRatingInterface;
  /**
   *
   *
   */
  supplierType?: Maybe<Array<Scalars['String']['output']>>;
  /**
   *
   *
   */
  terms?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  title?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  totalCostWedding?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  user?: Maybe<User>;
};


export type AbstractRatingSetAverageArgs = {
  average: Scalars['Float']['input'];
};

export type AbstractRatingInterface = {
  /**
   *
   *
   */
  allowedToTakePartInRaffle: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  average: Scalars['Float']['output'];
  /**
   *
   *
   */
  bridalTickets?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  event?: Maybe<Event>;
  /**
   *
   *
   */
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  flexibility?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  isArchived: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  overallImpression?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pax?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  price?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pricePerformanceRatio?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  professionalism?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  qualityOfService?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  recommendation?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  responsiveness?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  reviewerIsBridalCouple: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  reviewerRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  reviewerTickets?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  setAverage: AbstractRatingInterface;
  /**
   *
   *
   */
  supplierType?: Maybe<Array<Scalars['String']['output']>>;
  /**
   *
   *
   */
  terms?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  title?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  totalCostWedding?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  user?: Maybe<User>;
};


export type AbstractRatingInterfaceSetAverageArgs = {
  average: Scalars['Float']['input'];
};

export type AbstractServiceProvider = AbstractServiceProviderInterface & {
  __typename?: 'AbstractServiceProvider';
  /**
   *
   *
   */
  address?: Maybe<Address>;
  /**
   *
   *
   */
  addressValidated?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  addressValidationDisabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  allMedias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  canReceiveInquiries: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  city?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityForSlug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityUrl: Scalars['String']['output'];
  /**
   *
   *
   */
  claimType?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  company?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactFirstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactLastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  countOfInquiries: Scalars['Int']['output'];
  /**
   *
   *
   */
  countOfOutboundLinks: Scalars['Int']['output'];
  /**
   *
   *
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  creatorRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  creatorUser?: Maybe<User>;
  /**
   *
   *
   */
  criteriaCategories: Array<CriteriaCategoryType>;
  /**
   *
   *
   */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  defaultMedia?: Maybe<ServiceProviderMedia>;
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  disableInquiry: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  facebook?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  hasRatings: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  hasStoppedService: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  highlights: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  images: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  inquiries?: Maybe<Array<ServiceProviderInquiry>>;
  /**
   *
   *
   */
  inquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  instagram?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  intro?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  isClaimRequestAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isClaimed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isInquiryAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isOwnershipDenied: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  links: Array<Link>;
  /**
   *
   *
   */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  medias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  moderationRequired: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  nearbyCities: Array<City>;
  /**
   *
   *
   */
  nearbyServiceProviders: Array<ServiceProviderSearchResult>;
  /**
   *
   *
   */
  noIndex: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  owner?: Maybe<User>;
  /**
   *
   *
   */
  ownerRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  ownerStatus?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  pinterest?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  placeHolderImage?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  premium: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  premiumUntil?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  priceNiveau?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  published: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  ratings?: Maybe<PorpaginasResult_AbstractRatingInterface>;
  /**
   *
   *
   */
  ratingsAverage?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  ratingsCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  ratingsOverview?: Maybe<ServiceProviderRatingOverview>;
  /**
   *
   *
   */
  recommendationRate?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  recommendationsCount?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  showNearbyServiceProviders: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  showOnlyForAdmin?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  showRaffle: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  state?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  statistics?: Maybe<Array<KeyValueType>>;
  /**
   *
   *
   */
  stoppedServiceAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  street1?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  street2?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  structuredData: Scalars['String']['output'];
  /**
   *
   *
   */
  twitter?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  type: Scalars['String']['output'];
  /**
   *
   *
   */
  unansweredInquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  url?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  verified?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  viewedBy?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  vimeo?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  website?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  youtube?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  zip?: Maybe<Scalars['String']['output']>;
};


export type AbstractServiceProviderCanonicalUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type AbstractServiceProviderCityUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type AbstractServiceProviderNearbyServiceProvidersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AbstractServiceProviderInput = {
  slug: Scalars['String']['input'];
};

export type AbstractServiceProviderInterface = {
  /**
   *
   *
   */
  address?: Maybe<Address>;
  /**
   *
   *
   */
  addressValidated?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  addressValidationDisabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  allMedias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  canReceiveInquiries: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  city?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityForSlug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityUrl: Scalars['String']['output'];
  /**
   *
   *
   */
  claimType?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  company?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactFirstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactLastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  countOfInquiries: Scalars['Int']['output'];
  /**
   *
   *
   */
  countOfOutboundLinks: Scalars['Int']['output'];
  /**
   *
   *
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  creatorRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  creatorUser?: Maybe<User>;
  /**
   *
   *
   */
  criteriaCategories: Array<CriteriaCategoryType>;
  /**
   *
   *
   */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  defaultMedia?: Maybe<ServiceProviderMedia>;
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  disableInquiry: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  facebook?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  hasRatings: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  hasStoppedService: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  highlights: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  images: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  inquiries?: Maybe<Array<ServiceProviderInquiry>>;
  /**
   *
   *
   */
  inquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  instagram?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  intro?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  isClaimRequestAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isClaimed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isInquiryAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isOwnershipDenied: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  links: Array<Link>;
  /**
   *
   *
   */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  medias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  moderationRequired: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  nearbyCities: Array<City>;
  /**
   *
   *
   */
  nearbyServiceProviders: Array<ServiceProviderSearchResult>;
  /**
   *
   *
   */
  noIndex: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  owner?: Maybe<User>;
  /**
   *
   *
   */
  ownerRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  ownerStatus?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  pinterest?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  placeHolderImage?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  premium: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  premiumUntil?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  priceNiveau?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  published: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  ratings?: Maybe<PorpaginasResult_AbstractRatingInterface>;
  /**
   *
   *
   */
  ratingsAverage?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  ratingsCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  ratingsOverview?: Maybe<ServiceProviderRatingOverview>;
  /**
   *
   *
   */
  recommendationRate?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  recommendationsCount?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  showNearbyServiceProviders: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  showOnlyForAdmin?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  showRaffle: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  state?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  statistics?: Maybe<Array<KeyValueType>>;
  /**
   *
   *
   */
  stoppedServiceAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  street1?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  street2?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  structuredData: Scalars['String']['output'];
  /**
   *
   *
   */
  twitter?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  type: Scalars['String']['output'];
  /**
   *
   *
   */
  unansweredInquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  url?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  verified?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  viewedBy?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  vimeo?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  website?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  youtube?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  zip?: Maybe<Scalars['String']['output']>;
};


export type AbstractServiceProviderInterfaceCanonicalUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type AbstractServiceProviderInterfaceCityUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type AbstractServiceProviderInterfaceNearbyServiceProvidersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AbstractServiceProviderToEvent = {
  __typename?: 'AbstractServiceProviderToEvent';
  /**
   *
   *
   */
  abstractServiceProvider: AbstractServiceProviderInterface;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  event: Event;
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  serviceProvider: AbstractServiceProviderInterface;
};

export type Activity = {
  __typename?: 'Activity';
  /**
   *
   *
   */
  actor?: Maybe<User>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  isRead: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  linkOpenIn?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  message?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  type: Scalars['String']['output'];
  /**
   *
   *
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  usefulData: Array<KeyValueType>;
  /**
   *
   *
   */
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type ActivityByUuidInput = {
  uuid: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  /**
   *
   *
   */
  city?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  company?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  state?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  street1?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  street2?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  validated: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  validationDisabled: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  zip?: Maybe<Scalars['String']['output']>;
};

export type AffiliateProgram = {
  __typename?: 'AffiliateProgram';
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  isDefault: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isSelectableOnRegistration: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  payoutThreshold?: Maybe<Scalars['Int']['output']>;
};

export type AffiliateProgramInput = {
  id: Scalars['Int']['input'];
};

export type AffiliateSearch = {
  __typename?: 'AffiliateSearch';
  /**
   *
   *
   */
  affiliate?: Maybe<User>;
  /**
   *
   *
   */
  affiliateProgram?: Maybe<AffiliateProgram>;
  /**
   *
   *
   */
  hasMissingInformation?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  market?: Maybe<Market>;
  /**
   *
   *
   */
  onlyActiveUsers?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  searchTerm?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  service?: Maybe<Scalars['String']['output']>;
};

export type AffiliateSearchInput = {
  affiliate?: InputMaybe<UserByIdInput>;
  affiliateProgram?: InputMaybe<AffiliateProgramInput>;
  hasMissingInformation?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<MarketInput>;
  onlyActiveUsers?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliateStatistic = {
  __typename?: 'AffiliateStatistic';
  /**
   *
   *
   */
  leadQualityRatio?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  leadsCount?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  purchasesCount?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  sumOfApprovedConversions?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  sumOfPendingConversions?: Maybe<Scalars['Int']['output']>;
};

export type AffiliateStatistics = {
  __typename?: 'AffiliateStatistics';
  /**
   *
   *
   */
  from: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  period?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  search?: Maybe<AffiliateSearch>;
  /**
   *
   *
   */
  timeSpan?: Maybe<StatisticsTimeSpan>;
  /**
   *
   *
   */
  timeSpanDescriber?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  to: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  values?: Maybe<Array<Maybe<AffiliateStatisticsValue>>>;
};

export type AffiliateStatisticsInput = {
  period?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<AffiliateSearchInput>;
  timeSpan?: InputMaybe<StatisticsTimeSpanInput>;
  timeSpanDescriber?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliateStatisticsValue = {
  __typename?: 'AffiliateStatisticsValue';
  from: Scalars['DateTime']['output'];
  to: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  value: AffiliateStatistic;
};

export type AvailablePaymentMethods = {
  __typename?: 'AvailablePaymentMethods';
  /**
   *
   *
   */
  primary: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  secondary: Array<Scalars['String']['output']>;
};

export type Cart = {
  __typename?: 'Cart';
  /**
   *
   *
   */
  paid: Scalars['Boolean']['output'];
};

export type CartBooking = {
  __typename?: 'CartBooking';
  /**
   *
   *
   */
  cartId?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  paid: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  reference?: Maybe<Scalars['String']['output']>;
};

export type CartInquiry = {
  __typename?: 'CartInquiry';
  /**
   *
   *
   */
  cartId?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  paid: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  reference?: Maybe<Scalars['String']['output']>;
};

export type Category = {
  __typename?: 'Category';
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  locations: Array<Location>;
  /**
   *
   *
   */
  name: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  parentCategory?: Maybe<Category>;
  /**
   *
   *
   */
  slug: Scalars['String']['output'];
};

export type City = {
  __typename?: 'City';
  /**
   *
   *
   */
  amountOfWeddingsPerYear?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  country: Scalars['String']['output'];
  /**
   *
   *
   */
  fotoboxText?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  hasCityPage: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  image?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  introText?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  lat: Scalars['Float']['output'];
  /**
   *
   *
   */
  lng: Scalars['Float']['output'];
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  population?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  registryOffices: Array<RegistryOffice>;
  /**
   *
   *
   */
  slug: Scalars['String']['output'];
  /**
   *
   *
   */
  state: Scalars['String']['output'];
};

export type ClaimRequest = {
  __typename?: 'ClaimRequest';
  /**
   *
   *
   */
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  code?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  declineReason?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  declinedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  documentUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  initiatedByPersonnel: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  serviceProvider: AbstractServiceProviderInterface;
  /**
   *
   *
   */
  status?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  user: User;
  /**
   *
   *
   */
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type CriteriaCategoryType = {
  __typename?: 'CriteriaCategoryType';
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  properties: Array<Scalars['String']['output']>;
};

export type DesignTypeView = {
  __typename?: 'DesignTypeView';
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
};

export type Dj = AbstractMobileServiceProviderInterface & AbstractServiceProviderInterface & {
  __typename?: 'Dj';
  /**
   *
   *
   */
  address?: Maybe<Address>;
  /**
   *
   *
   */
  addressValidated?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  addressValidationDisabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  allMedias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  basePrice?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  canReceiveInquiries: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  city?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityForSlug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityUrl: Scalars['String']['output'];
  /**
   *
   *
   */
  claimType?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  company?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactFirstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactLastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  countOfInquiries: Scalars['Int']['output'];
  /**
   *
   *
   */
  countOfOutboundLinks: Scalars['Int']['output'];
  /**
   *
   *
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  creatorRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  creatorUser?: Maybe<User>;
  /**
   *
   *
   */
  criteriaCategories: Array<CriteriaCategoryType>;
  /**
   *
   *
   */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  defaultMedia?: Maybe<ServiceProviderMedia>;
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  disableInquiry: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  equipmentPriceFor50Pax?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  equipmentPriceFor100Pax?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  equipmentPriceFor150Pax?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  equipmentPriceFor250Pax?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  equipmentPriceFor500Pax?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  facebook?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  hasRatings: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  hasStoppedService: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  highlights: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  images: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  inquiries?: Maybe<Array<ServiceProviderInquiry>>;
  /**
   *
   *
   */
  inquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  instagram?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  intro?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  isClaimRequestAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isClaimed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isInquiryAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isOwnershipDenied: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  links: Array<Link>;
  /**
   *
   *
   */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  maximumTravelDistance?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  medias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  moderationRequired: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  nearbyCities: Array<City>;
  /**
   *
   *
   */
  nearbyServiceProviders: Array<ServiceProviderSearchResult>;
  /**
   *
   *
   */
  noIndex: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  owner?: Maybe<User>;
  /**
   *
   *
   */
  ownerRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  ownerStatus?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  pinterest?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  placeHolderImage?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  premium: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  premiumUntil?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  priceNiveau?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pricePerHour?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pricePerKilometer?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  published: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  ratings?: Maybe<PorpaginasResult_AbstractRatingInterface>;
  /**
   *
   *
   */
  ratingsAverage?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  ratingsCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  ratingsOverview?: Maybe<ServiceProviderRatingOverview>;
  /**
   *
   *
   */
  recommendationRate?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  recommendationsCount?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  showNearbyServiceProviders: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  showOnlyForAdmin?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  showRaffle: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  state?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  statistics?: Maybe<Array<KeyValueType>>;
  /**
   *
   *
   */
  stoppedServiceAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  street1?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  street2?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  structuredData: Scalars['String']['output'];
  /**
   *
   *
   */
  twitter?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  type: Scalars['String']['output'];
  /**
   *
   *
   */
  unansweredInquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  url?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  verified?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  viewedBy?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  vimeo?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  website?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  youtube?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  zip?: Maybe<Scalars['String']['output']>;
};


export type DjCanonicalUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type DjCityUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type DjNearbyServiceProvidersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type DjRating = AbstractRatingInterface & {
  __typename?: 'DjRating';
  /**
   *
   *
   */
  allowedToTakePartInRaffle: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  average: Scalars['Float']['output'];
  /**
   *
   *
   */
  bridalTickets?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  event?: Maybe<Event>;
  /**
   *
   *
   */
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  flexibility?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  isArchived: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  overallImpression?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pax?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  price?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pricePerformanceRatio?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  professionalism?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  qualityOfService?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  recommendation?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  responsiveness?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  reviewerIsBridalCouple: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  reviewerRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  reviewerTickets?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  setAverage: AbstractRatingInterface;
  /**
   *
   *
   */
  supplierType?: Maybe<Array<Scalars['String']['output']>>;
  /**
   *
   *
   */
  terms?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  title?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  totalCostWedding?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  user?: Maybe<User>;
};


export type DjRatingSetAverageArgs = {
  average: Scalars['Float']['input'];
};

export type Event = {
  __typename?: 'Event';
  /**
   *
   *
   */
  date: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  eventDashboardWidgets: Array<EventDashboardWidget>;
  /**
   *
   *
   */
  eventGuestCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  eventGuests?: Maybe<Array<Maybe<UserAnonymous>>>;
  /**
   *
   *
   */
  eventImage?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  eventScheduleItems: PorpaginasResult_EventScheduleItem;
  /**
   *
   *
   */
  eventType: Scalars['String']['output'];
  /**
   *
   *
   */
  hasPhotoboothImages: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  imageCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  inPrivateLocation: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  location?: Maybe<Location>;
  /**
   *
   *
   */
  photoAppAllowed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  reference: Scalars['String']['output'];
  /**
   *
   *
   */
  showLocationRatingBanner: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  showSetLocationBanner: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  title?: Maybe<Scalars['String']['output']>;
};


export type EventEventImageArgs = {
  transformation?: InputMaybe<Scalars['String']['input']>;
};

export type EventByReferenceInput = {
  reference: Scalars['String']['input'];
};

export type EventDashboardWidget = {
  __typename?: 'EventDashboardWidget';
  /**
   *
   *
   */
  graphicalBanner?: Maybe<EventDashboardWidgetGraphicalBanner>;
  /**
   *
   *
   */
  graphicalBannerCollection?: Maybe<EventDashboardWidgetGraphicalBannerCollection>;
  /**
   *
   *
   */
  sectionTitle?: Maybe<EventDashboardWidgetSectionTitle>;
  /**
   *
   *
   */
  type: Scalars['String']['output'];
};

export type EventDashboardWidgetGraphicalBanner = {
  __typename?: 'EventDashboardWidgetGraphicalBanner';
  /**
   *
   *
   */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  buttonText: Scalars['String']['output'];
  /**
   *
   *
   */
  headline: Scalars['String']['output'];
  /**
   *
   *
   */
  linkTarget: Scalars['String']['output'];
  /**
   *
   *
   */
  linkUrl: Scalars['String']['output'];
  /**
   *
   *
   */
  text: Scalars['String']['output'];
};

export type EventDashboardWidgetGraphicalBannerCollection = {
  __typename?: 'EventDashboardWidgetGraphicalBannerCollection';
  /**
   *
   *
   */
  graphicalBanners: Array<EventDashboardWidgetGraphicalBanner>;
};

export type EventDashboardWidgetMetadata = {
  __typename?: 'EventDashboardWidgetMetadata';
  /**
   *
   *
   */
  key: Scalars['String']['output'];
  /**
   *
   *
   */
  value: Scalars['String']['output'];
};

export type EventDashboardWidgetSectionTitle = {
  __typename?: 'EventDashboardWidgetSectionTitle';
  /**
   *
   *
   */
  title: Scalars['String']['output'];
};

export type EventForGuestByReferenceInput = {
  reference: Scalars['String']['input'];
};

export type EventResponse = {
  __typename?: 'EventResponse';
  /**
   *
   *
   */
  event: Event;
  /**
   *
   *
   */
  userToEvent: UserToEvent;
};

export type EventScheduleItem = {
  __typename?: 'EventScheduleItem';
  /**
   *
   *
   */
  city?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  inEventLocation: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  startAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  state?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  street1?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  street2?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  title: Scalars['String']['output'];
  /**
   *
   *
   */
  uuid?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  zip?: Maybe<Scalars['String']['output']>;
};

export type EventScheduleItemByIdInput = {
  uuid: Scalars['String']['input'];
};

export type EventTask = {
  __typename?: 'EventTask';
  /**
   *
   *
   */
  allGuestsNeedToDoIt: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  event: Event;
  /**
   *
   *
   */
  freeText?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  numberOfGuests: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  task?: Maybe<PhotoBoothGameTask>;
  /**
   *
   *
   */
  uuid: Scalars['ID']['output'];
};

export type EventTaskToUser = {
  __typename?: 'EventTaskToUser';
  /**
   *
   *
   */
  done: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  skipped: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  task?: Maybe<EventTask>;
  /**
   *
   *
   */
  uuid: Scalars['ID']['output'];
};

export type EventTaskToUserByIdInput = {
  uuid: Scalars['String']['input'];
};

export type EventTodos = {
  __typename?: 'EventTodos';
  /**
   *
   *
   */
  type: Scalars['String']['output'];
  /**
   *
   *
   */
  url: Array<Scalars['String']['output']>;
};

export type EventView = {
  __typename?: 'EventView';
  /**
   *
   *
   */
  date: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  photoAppAllowed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  reference: Scalars['String']['output'];
  /**
   *
   *
   */
  showLocationRatingBanner: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  showSetLocationBanner: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  title: Scalars['String']['output'];
};

export type FeatureStarRating = {
  __typename?: 'FeatureStarRating';
  /**
   *
   *
   */
  feature: Scalars['String']['output'];
  /**
   *
   *
   */
  stars?: Maybe<Scalars['Float']['output']>;
};

export type Feedback = {
  __typename?: 'Feedback';
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  source: Scalars['String']['output'];
  /**
   *
   *
   */
  text: Scalars['String']['output'];
  /**
   *
   *
   */
  user: User;
  /**
   *
   *
   */
  version?: Maybe<Scalars['String']['output']>;
};

export type GalleryImageView = {
  __typename?: 'GalleryImageView';
  /**
   *
   *
   */
  booking?: Maybe<AbstractBookingFrontendView>;
  /**
   *
   *
   */
  collage: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  createdByUser?: Maybe<UserView>;
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  detail?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  filename?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  imageComments: Array<ImageCommentView>;
  /**
   *
   *
   */
  imageLikeCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  synchronized: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type GalleryView = {
  __typename?: 'GalleryView';
  /**
   *
   *
   */
  event?: Maybe<EventView>;
  /**
   *
   *
   */
  galleryImages: Array<GalleryImageView>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
};

export type Image = {
  __typename?: 'Image';
  /**
   *
   *
   */
  booking?: Maybe<AbstractBooking>;
  /**
   *
   *
   */
  collage: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  collageImages: Array<Image>;
  /**
   *
   *
   */
  commentCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  createdByUser?: Maybe<User>;
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  detail?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  filename: Scalars['String']['output'];
  /**
   *
   *
   */
  hotnessScore: Scalars['Int']['output'];
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  imageComments: Array<ImageComment>;
  /**
   *
   *
   */
  imageCommentsCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  imageLikeCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  imageReports: Array<ImageReport>;
  /**
   *
   *
   */
  likeCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  liked: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  reported: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  shareUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  synchronized: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  takenAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  willBeDeleted: Scalars['Boolean']['output'];
};


export type ImageDetailArgs = {
  transformationDetail?: InputMaybe<Scalars['String']['input']>;
};


export type ImageDownloadUrlArgs = {
  transformationDetail?: InputMaybe<Scalars['String']['input']>;
};


export type ImageShareUrlArgs = {
  transformationDetail?: InputMaybe<Scalars['String']['input']>;
};


export type ImageThumbnailArgs = {
  transformationThumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type ImageComment = {
  __typename?: 'ImageComment';
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  image: Image;
  /**
   *
   *
   */
  text: Scalars['String']['output'];
  /**
   *
   *
   */
  user: User;
};

export type ImageCommentView = {
  __typename?: 'ImageCommentView';
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  text?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  user?: Maybe<UserView>;
};

export type ImageLike = {
  __typename?: 'ImageLike';
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  image: Image;
  /**
   *
   *
   */
  user: User;
};

export type ImageReport = {
  __typename?: 'ImageReport';
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  deletedByUser?: Maybe<User>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  image: Image;
  /**
   *
   *
   */
  reportReason: Scalars['String']['output'];
  /**
   *
   *
   */
  user: User;
};

export type KeyValue = {
  __typename?: 'KeyValue';
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  key: Scalars['String']['output'];
  /**
   *
   *
   */
  value: Scalars['String']['output'];
};

export type KeyValueType = {
  __typename?: 'KeyValueType';
  /**
   *
   *
   */
  key: Scalars['String']['output'];
  /**
   *
   *
   */
  value: Scalars['String']['output'];
};

export type Link = {
  __typename?: 'Link';
  /**
   *
   *
   */
  type: Scalars['String']['output'];
  /**
   *
   *
   */
  url: Scalars['String']['output'];
};

export type Location = AbstractServiceProviderInterface & {
  __typename?: 'Location';
  /**
   *
   *
   */
  accommodationAvailable?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  accommodationIncluded?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  accommodationPax?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  accommodationPrice?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  accommodationRentMandatory?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  address?: Maybe<Address>;
  /**
   *
   *
   */
  addressValidated?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  addressValidationDisabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  allMedias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  canReceiveInquiries: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  categories: Array<Category>;
  /**
   *
   *
   */
  cateringCookingStyle?: Maybe<Array<Scalars['String']['output']>>;
  /**
   *
   *
   */
  cateringExternalAllowed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  cateringFromLocation?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  cateringPriceMin?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  cateringType?: Maybe<Array<Scalars['String']['output']>>;
  /**
   *
   *
   */
  city?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityForSlug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityUrl: Scalars['String']['output'];
  /**
   *
   *
   */
  claimType?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  company?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactFirstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactLastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  countOfInquiries: Scalars['Int']['output'];
  /**
   *
   *
   */
  countOfOutboundLinks: Scalars['Int']['output'];
  /**
   *
   *
   */
  countOfRooms?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  creatorRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  creatorUser?: Maybe<User>;
  /**
   *
   *
   */
  criteriaCategories: Array<CriteriaCategoryType>;
  /**
   *
   *
   */
  curfew?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  defaultMedia?: Maybe<ServiceProviderMedia>;
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  disableInquiry: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  drinksAvailableDrinks?: Maybe<Array<Scalars['String']['output']>>;
  /**
   *
   *
   */
  drinksExternalAllowed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  drinksFromLocation?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  drinksPriceModel?: Maybe<Array<Scalars['String']['output']>>;
  /**
   *
   *
   */
  drinksPriceModelFlatrate: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  emptyRoom?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  exclusiveRentalPossible?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  facebook?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  hasRatings: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  hasStoppedService: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  highlights: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  images: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  inquiries?: Maybe<Array<ServiceProviderInquiry>>;
  /**
   *
   *
   */
  inquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  instagram?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  intro?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  isClaimRequestAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isClaimed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isInquiryAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isOwnershipDenied: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  links: Array<Link>;
  /**
   *
   *
   */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  medias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  moderationRequired: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  nearbyCities: Array<City>;
  /**
   *
   *
   */
  nearbyServiceProviders: Array<ServiceProviderSearchResult>;
  /**
   *
   *
   */
  noIndex: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  openEnd?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  outsideAreaAvailable?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  owner?: Maybe<User>;
  /**
   *
   *
   */
  ownerRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  ownerStatus?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  parkingAvailable?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  paxMax?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  paxMin?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  pinterest?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  placeHolderImage?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  premium: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  premiumUntil?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  priceNiveau?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  published: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  ratings?: Maybe<PorpaginasResult_AbstractRatingInterface>;
  /**
   *
   *
   */
  ratingsAverage?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  ratingsCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  ratingsOverview?: Maybe<ServiceProviderRatingOverview>;
  /**
   *
   *
   */
  recommendationRate?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  recommendationsCount?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  roomRentPrice?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  roomRentRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  seatingForm?: Maybe<Array<Scalars['String']['output']>>;
  /**
   *
   *
   */
  servicePersonnelExternalAllowed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  servicePersonnelFromLocation?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  showNearbyServiceProviders: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  showOnlyForAdmin?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  showRaffle: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  sizeOfRooms?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  state?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  statistics?: Maybe<Array<KeyValueType>>;
  /**
   *
   *
   */
  stoppedServiceAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  street1?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  street2?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  structuredData: Scalars['String']['output'];
  /**
   *
   *
   */
  twitter?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  type: Scalars['String']['output'];
  /**
   *
   *
   */
  unansweredInquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  url?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  verified?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  viewedBy?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  vimeo?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  volumeLimit?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  volumeLimitMaxDecibel?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  volumeLimitTime?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  website?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  youtube?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  zip?: Maybe<Scalars['String']['output']>;
};


export type LocationCanonicalUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type LocationCityUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type LocationNearbyServiceProvidersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationRating = AbstractRatingInterface & {
  __typename?: 'LocationRating';
  /**
   *
   *
   */
  accommodationAvailable?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  accommodationIncluded?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  accommodationPrice?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  accommodationRentMandatory?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  accommodationUsed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  allowedToTakePartInRaffle: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  atmosphere?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  average: Scalars['Float']['output'];
  /**
   *
   *
   */
  bridalTickets?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  cateringFoodQuality?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  cateringFromLocation?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  cateringPricePerPerson?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  cateringType?: Maybe<Array<Scalars['String']['output']>>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  curfew?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  drinksAvailableDrinks?: Maybe<Array<Scalars['String']['output']>>;
  /**
   *
   *
   */
  drinksFromLocation?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  drinksPricePerPerson?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  drinksSelectionQuality?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  event?: Maybe<Event>;
  /**
   *
   *
   */
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  exclusiveRental?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  flexibility?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  isArchived: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  openEnd?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  outsideAreaAvailable?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  outsideAreaQuality?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  overallImpression?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  parkingAvailable?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  pax?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  price?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pricePerformanceRatio?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  professionalism?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  qualityOfService?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  recommendation?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  responsiveness?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  reviewerIsBridalCouple: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  reviewerRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  reviewerTickets?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  roomRentPaid?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  roomRentPrice?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  rooms?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  seatingForm: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  servicePersonellFromLocation?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  servicePersonnelCompetence?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  servicePersonnelFriendliness?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  servicePersonnelUsedFromLocation?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  setAverage: AbstractRatingInterface;
  /**
   *
   *
   */
  staffFriendliness?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  supplierType?: Maybe<Array<Scalars['String']['output']>>;
  /**
   *
   *
   */
  surrounding?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  terms?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  title?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  totalCostWedding?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  user?: Maybe<User>;
  /**
   *
   *
   */
  volumeLimit?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  volumeLimitTime?: Maybe<Scalars['String']['output']>;
};


export type LocationRatingSetAverageArgs = {
  average: Scalars['Float']['input'];
};

export type Market = {
  __typename?: 'Market';
  /**
   *
   *
   */
  availableServices: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  companyName: Scalars['String']['output'];
  /**
   *
   *
   */
  currency: Scalars['String']['output'];
  /**
   *
   *
   */
  dateFormat: Scalars['String']['output'];
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  forbiddenStates: Array<State>;
  /**
   *
   *
   */
  hasIndexPage: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  hasOffice: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  hasServiceProviderSearch: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  internationalDiallingCode?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  isLandStates: Array<State>;
  /**
   *
   *
   */
  isMarketingActive?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  islandStates: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  key: Scalars['String']['output'];
  /**
   *
   *
   */
  keyLower: Scalars['String']['output'];
  /**
   *
   *
   */
  languages: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  name: Translation;
  /**
   *
   *
   */
  officeCity?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  officeLatitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  officeLongitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  officeStreet1?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  officeStreet2?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  officeZip?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  paymentMethods?: Maybe<AvailablePaymentMethods>;
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  phoneCompact: Scalars['String']['output'];
  /**
   *
   *
   */
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  showInMarketSelect: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  textReplacements: Array<TextReplacement>;
};

export type MarketActivation = {
  __typename?: 'MarketActivation';
  /**
   *
   *
   */
  AT?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  BE?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  CH?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  DE?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  DK?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  ES?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  FR?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  GB?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  IT?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  LU?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  NL?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  PL?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  US?: Maybe<Scalars['Boolean']['output']>;
};

export type MarketChoiceInput = {
  AT?: InputMaybe<Scalars['Boolean']['input']>;
  BE?: InputMaybe<Scalars['Boolean']['input']>;
  CH?: InputMaybe<Scalars['Boolean']['input']>;
  DE?: InputMaybe<Scalars['Boolean']['input']>;
  DK?: InputMaybe<Scalars['Boolean']['input']>;
  ES?: InputMaybe<Scalars['Boolean']['input']>;
  FR?: InputMaybe<Scalars['Boolean']['input']>;
  GB?: InputMaybe<Scalars['Boolean']['input']>;
  IT?: InputMaybe<Scalars['Boolean']['input']>;
  LU?: InputMaybe<Scalars['Boolean']['input']>;
  NL?: InputMaybe<Scalars['Boolean']['input']>;
  PL?: InputMaybe<Scalars['Boolean']['input']>;
  US?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketConfiguration = {
  __typename?: 'MarketConfiguration';
  /**
   *
   *
   *
   */
  AT: Array<KeyValueType>;
  /**
   *
   *
   *
   */
  BE: Array<KeyValueType>;
  /**
   *
   *
   *
   */
  CH: Array<KeyValueType>;
  /**
   *
   *
   *
   */
  DE: Array<KeyValueType>;
  /**
   *
   *
   *
   */
  DK: Array<KeyValueType>;
  /**
   *
   *
   *
   */
  ES: Array<KeyValueType>;
  /**
   *
   *
   *
   */
  FR: Array<KeyValueType>;
  /**
   *
   *
   *
   */
  GB: Array<KeyValueType>;
  /**
   *
   *
   *
   */
  IT: Array<KeyValueType>;
  /**
   *
   *
   *
   */
  LU: Array<KeyValueType>;
  /**
   *
   *
   *
   */
  NL: Array<KeyValueType>;
  /**
   *
   *
   *
   */
  PL: Array<KeyValueType>;
  /**
   *
   *
   *
   */
  US: Array<KeyValueType>;
};

export type MarketInput = {
  key: Scalars['String']['input'];
};

export type Markets = {
  __typename?: 'Markets';
  /**
   *
   *
   */
  AT: Market;
  /**
   *
   *
   */
  BE: Market;
  /**
   *
   *
   */
  CH: Market;
  /**
   *
   *
   */
  DE: Market;
  /**
   *
   *
   */
  DK: Market;
  /**
   *
   *
   */
  ES: Market;
  /**
   *
   *
   */
  FR: Market;
  /**
   *
   *
   */
  GB: Market;
  /**
   *
   *
   */
  IT: Market;
  /**
   *
   *
   */
  LU: Market;
  /**
   *
   *
   */
  NL: Market;
  /**
   *
   *
   */
  PL: Market;
  /**
   *
   *
   */
  US: Market;
};

export type Message = {
  __typename?: 'Message';
  /**
   *
   *
   */
  content: Scalars['String']['output'];
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  isSender: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  latestActionAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  messageChildren: PorpaginasResult_Message;
  /**
   *
   *
   */
  parentMessage?: Maybe<Message>;
  /**
   *
   *
   */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  recipient?: Maybe<User>;
  /**
   *
   *
   */
  sender: User;
  /**
   *
   *
   */
  serviceProviderInquiry?: Maybe<ServiceProviderInquiry>;
  /**
   *
   *
   */
  serviceProviderInquiryOffer?: Maybe<ServiceProviderInquiryOffer>;
  /**
   *
   *
   */
  subject?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  type: Scalars['String']['output'];
  /**
   *
   *
   */
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type MessageByUuidInput = {
  uuid: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   *
   *
   */
  acceptOffer: ServiceProviderInquiryOffer;
  /**
   *
   *
   */
  addNetPromoter: NetPromoter;
  /**
   *
   *
   */
  addNote?: Maybe<Message>;
  /**
   *
   *
   */
  addServiceProviderToEvent: Event;
  /**
   *
   *
   */
  assignOwner: AbstractServiceProviderInterface;
  /**
   *
   *
   */
  blockUser: UserToEvent;
  /**
   *
   *
   */
  claimServiceProvider: AbstractServiceProviderInterface;
  /**
   *
   *
   */
  clearReport: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  closeServiceProvider: AbstractServiceProviderInterface;
  /**
   *
   *
   */
  createEvent: Event;
  /**
   *
   *
   */
  createEventScheduleItem: EventScheduleItem;
  /**
   *
   *
   */
  createImageComment: Image;
  /**
   *
   *
   */
  createOffer: ServiceProviderInquiryOffer;
  /**
   *
   *
   */
  createPhotoBoothGameCategory: PhotoBoothGameCategory;
  /**
   *
   *
   */
  createPhotoBoothGameTask: PhotoBoothGameTask;
  /**
   *
   *
   */
  createPrivateTask: PhotoBoothGameTask;
  /**
   *
   *
   */
  createServiceProviderDj: Dj;
  /**
   *
   *
   */
  createServiceProviderLocation: Location;
  /**
   *
   *
   */
  createServiceProviderPhotographer: Photographer;
  /**
   *
   *
   */
  createServiceProviderWeddingFair: WeddingFair;
  /**
   *
   *
   */
  createServiceVoucher: ServiceVoucher;
  /**
   *
   *
   */
  declineOffer: ServiceProviderInquiryOffer;
  /**
   *
   *
   */
  deleteActivity: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  deleteEventScheduleItem: PorpaginasResult_EventScheduleItem;
  /**
   *
   *
   */
  deleteImage: Image;
  /**
   *
   *
   */
  deleteImageComment: Image;
  /**
   *
   *
   */
  deleteMessage: Message;
  /**
   *
   *
   */
  deleteOffer?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  deletePhotoBoothGameCategory?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  deletePhotoBoothGameTask?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  deleteServiceProvider: AbstractServiceProviderInterface;
  /**
   *
   *
   */
  deleteUserAccount: Scalars['String']['output'];
  /**
   *
   *
   */
  editUser: User;
  /**
   *
   *
   */
  enableTaskForEvent: EventTask;
  /**
   *
   *
   */
  enterClaimRequestCode: AbstractServiceProviderInterface;
  /**
   *
   *
   */
  feedback: Feedback;
  /**
   *
   *
   */
  joinEvent: UserToEvent;
  /**
   *
   *
   */
  linkDeviceToUser?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  markActivitiesAsReadByContext?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  markActivityAsRead: Activity;
  /**
   *
   *
   */
  markMessageAsRead: Message;
  /**
   *
   *
   */
  markTaskAsDone: EventTaskToUser;
  /**
   *
   *
   */
  passwordLogin?: Maybe<UserRegistration>;
  /**
   *
   *
   */
  registerUser?: Maybe<UserRegistration>;
  /**
   *
   *
   */
  removeDeviceToUser: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  removeOwner: Scalars['String']['output'];
  /**
   *
   *
   */
  removeVoucherFromCarts: ServiceVoucher;
  /**
   *
   *
   */
  reopenServiceProvider: AbstractServiceProviderInterface;
  /**
   *
   *
   */
  replyToMessage: Message;
  /**
   *
   *
   */
  reportImage: Image;
  /**
   *
   *
   */
  republishRating: RatingMutationResponse;
  /**
   *
   *
   */
  requestAutoLoginToken?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  requestLoginToken: RequestLoginTokenResult;
  /**
   *
   *
   */
  revokeOffer: ServiceProviderInquiryOffer;
  /**
   *
   *
   */
  serviceProviderAcceptOwnership: AbstractServiceProviderInterface;
  /**
   *
   *
   */
  serviceProviderDenyOwnership: AbstractServiceProviderInterface;
  /**
   *
   *
   */
  serviceProviderToEvent: AbstractServiceProviderToEvent;
  /**
   *
   *
   */
  skipTask: EventTaskToUser;
  /**
   *
   *
   */
  synchronizeEventImage: Event;
  /**
   *
   *
   */
  synchronizeImage?: Maybe<Image>;
  /**
   *
   *
   */
  synchronizeUserProfileImage: User;
  /**
   *
   *
   */
  toggleImageLike: Image;
  /**
   *
   *
   */
  tokenLogin?: Maybe<UserRegistration>;
  /**
   *
   *
   */
  unblockUser: UserToEvent;
  /**
   *
   *
   */
  unsetServiceProviderFromEvent: Event;
  /**
   *
   *
   */
  updateCity: City;
  /**
   *
   *
   */
  updateDefaultMediaForServiceProvider: AbstractServiceProviderInterface;
  /**
   *
   *
   */
  updateEvent: Event;
  /**
   *
   *
   */
  updateEventScheduleItem: EventScheduleItem;
  /**
   *
   *
   */
  updateKeyValue: KeyValue;
  /**
   *
   *
   */
  updatePhotoBoothGameCategory: PhotoBoothGameCategory;
  /**
   *
   *
   */
  updatePhotoBoothGameTask: PhotoBoothGameTask;
  /**
   *
   *
   */
  updateServiceProviderDj: Dj;
  /**
   *
   *
   */
  updateServiceProviderLocation: Location;
  /**
   *
   *
   */
  updateServiceProviderPhotographer: Photographer;
  /**
   *
   *
   */
  updateServiceProviderWeddingFair: WeddingFair;
  /**
   *
   *
   */
  updateServiceVoucher: ServiceVoucher;
  /**
   *
   *
   */
  uploadEventImage: Event;
  /**
   *
   *
   */
  uploadGalleryImage: Image;
  /**
   *
   *
   */
  uploadUserImage: User;
};


export type MutationAcceptOfferArgs = {
  offerMessage: MessageByUuidInput;
};


export type MutationAddNetPromoterArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  score: Scalars['Int']['input'];
};


export type MutationAddNoteArgs = {
  content: Scalars['String']['input'];
  parentMessage: MessageByUuidInput;
};


export type MutationAddServiceProviderToEventArgs = {
  event: EventByReferenceInput;
  serviceProvider: ServiceProviderBySlugInput;
};


export type MutationAssignOwnerArgs = {
  serviceProviderSlug: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationBlockUserArgs = {
  deleteUserData?: InputMaybe<Scalars['Boolean']['input']>;
  reference: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationClaimServiceProviderArgs = {
  serviceProviderSlug: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationClearReportArgs = {
  imageId: Scalars['Int']['input'];
  reference: Scalars['String']['input'];
};


export type MutationCloseServiceProviderArgs = {
  serviceProviderSlug: Scalars['String']['input'];
  transferDataToSlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateEventArgs = {
  eventDate: Scalars['String']['input'];
  eventTitle: Scalars['String']['input'];
  eventType: Scalars['String']['input'];
  marketKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateEventScheduleItemArgs = {
  eventScheduleItemInput?: InputMaybe<CreateEventScheduleItemInput>;
};


export type MutationCreateImageCommentArgs = {
  comment: Scalars['String']['input'];
  imageId: Scalars['Int']['input'];
};


export type MutationCreateOfferArgs = {
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  offerInput?: InputMaybe<CreateServiceProviderInquiryOfferInput>;
};


export type MutationCreatePhotoBoothGameCategoryArgs = {
  photoBoothGameCategoryInput?: InputMaybe<CreatePhotoBoothGameCategoryInput>;
};


export type MutationCreatePhotoBoothGameTaskArgs = {
  photoBoothGameTaskInput: CreatePhotoBoothGameTaskInput;
};


export type MutationCreatePrivateTaskArgs = {
  eventTaskInput: CreateEventTaskInput;
};


export type MutationCreateServiceProviderDjArgs = {
  serviceProvider: CreateDj;
};


export type MutationCreateServiceProviderLocationArgs = {
  serviceProvider: CreateLocation;
};


export type MutationCreateServiceProviderPhotographerArgs = {
  serviceProvider: CreatePhotographer;
};


export type MutationCreateServiceProviderWeddingFairArgs = {
  serviceProvider: CreateWeddingFair;
};


export type MutationCreateServiceVoucherArgs = {
  serviceVoucher: CreateServiceVoucherInput;
};


export type MutationDeclineOfferArgs = {
  offerMessage: MessageByUuidInput;
};


export type MutationDeleteActivityArgs = {
  activity: ActivityByUuidInput;
};


export type MutationDeleteEventScheduleItemArgs = {
  eventScheduleItem: EventScheduleItemByIdInput;
};


export type MutationDeleteImageArgs = {
  imageId: Scalars['Int']['input'];
  reference: Scalars['String']['input'];
};


export type MutationDeleteImageCommentArgs = {
  imageCommentId: Scalars['Int']['input'];
};


export type MutationDeleteMessageArgs = {
  messageToDelete: MessageByUuidInput;
};


export type MutationDeleteOfferArgs = {
  offerMessage: MessageByUuidInput;
};


export type MutationDeletePhotoBoothGameCategoryArgs = {
  category: PhotoBoothGameCategoryByIdInput;
};


export type MutationDeletePhotoBoothGameTaskArgs = {
  task: PhotoBoothGameTaskByIdInput;
};


export type MutationDeleteServiceProviderArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  serviceProviderSlug: Scalars['String']['input'];
  transferDataToSlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditUserArgs = {
  user: UpdateUserInput;
};


export type MutationEnableTaskForEventArgs = {
  allGuestsNeedToDoIt?: InputMaybe<Scalars['Boolean']['input']>;
  event: OwnedEventByReferenceInput;
  freeText?: InputMaybe<Scalars['String']['input']>;
  numberOfGuests?: InputMaybe<Scalars['Int']['input']>;
  task: PhotoBoothGameTaskByIdInput;
};


export type MutationEnterClaimRequestCodeArgs = {
  code: Scalars['String']['input'];
  serviceProviderSlug: Scalars['String']['input'];
};


export type MutationFeedbackArgs = {
  createFeedback: CreateFeedback;
};


export type MutationJoinEventArgs = {
  reference: Scalars['String']['input'];
};


export type MutationLinkDeviceToUserArgs = {
  deviceToken: Scalars['String']['input'];
};


export type MutationMarkActivitiesAsReadByContextArgs = {
  context: Scalars['String']['input'];
};


export type MutationMarkActivityAsReadArgs = {
  activity: ActivityByUuidInput;
};


export type MutationMarkMessageAsReadArgs = {
  message: MessageByUuidInput;
};


export type MutationMarkTaskAsDoneArgs = {
  eventTaskToUser: EventTaskToUserByIdInput;
};


export type MutationPasswordLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationRegisterUserArgs = {
  user: CreateUser;
};


export type MutationRemoveDeviceToUserArgs = {
  deviceToken: Scalars['String']['input'];
};


export type MutationRemoveOwnerArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationRemoveVoucherFromCartsArgs = {
  serviceVoucher: RemoveServiceVoucherFromCarts;
};


export type MutationReopenServiceProviderArgs = {
  serviceProviderSlug: Scalars['String']['input'];
};


export type MutationReplyToMessageArgs = {
  content: Scalars['String']['input'];
  parentMessage: MessageByUuidInput;
};


export type MutationReportImageArgs = {
  imageId: Scalars['Int']['input'];
  reference: Scalars['String']['input'];
  reportReason: Scalars['String']['input'];
};


export type MutationRepublishRatingArgs = {
  rating: RatingByIdAndTypeInput;
};


export type MutationRequestAutoLoginTokenArgs = {
  email: Scalars['String']['input'];
  isAppLogin?: InputMaybe<Scalars['Boolean']['input']>;
  redirectUrl: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestLoginTokenArgs = {
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRevokeOfferArgs = {
  offerMessage: MessageByUuidInput;
};


export type MutationServiceProviderAcceptOwnershipArgs = {
  serviceProviderSlug: Scalars['String']['input'];
};


export type MutationServiceProviderDenyOwnershipArgs = {
  serviceProviderSlug: Scalars['String']['input'];
};


export type MutationServiceProviderToEventArgs = {
  eventId: Scalars['Int']['input'];
  serviceProviderSlug: Scalars['String']['input'];
};


export type MutationSkipTaskArgs = {
  eventTaskToUser: EventTaskToUserByIdInput;
};


export type MutationSynchronizeEventImageArgs = {
  event: EventByReferenceInput;
  filename: Scalars['String']['input'];
};


export type MutationSynchronizeImageArgs = {
  fileName: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};


export type MutationSynchronizeUserProfileImageArgs = {
  filename: Scalars['String']['input'];
};


export type MutationToggleImageLikeArgs = {
  imageId: Scalars['Int']['input'];
};


export type MutationTokenLoginArgs = {
  token: Scalars['String']['input'];
};


export type MutationUnblockUserArgs = {
  reference: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUnsetServiceProviderFromEventArgs = {
  event: EventByReferenceInput;
  serviceProviderType: Scalars['String']['input'];
};


export type MutationUpdateCityArgs = {
  amountOfWeddingsPerYear?: InputMaybe<Scalars['Int']['input']>;
  citySlug: Scalars['String']['input'];
  fotoboxText?: InputMaybe<Scalars['String']['input']>;
  hasCityPage: Scalars['Boolean']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  introText?: InputMaybe<Scalars['String']['input']>;
  population?: InputMaybe<Scalars['Int']['input']>;
  registryOffices: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDefaultMediaForServiceProviderArgs = {
  serviceProviderMediaId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type MutationUpdateEventArgs = {
  event: EventByReferenceInput;
  eventInput: UpdateEventInput;
};


export type MutationUpdateEventScheduleItemArgs = {
  eventScheduleItem: EventScheduleItemByIdInput;
  eventScheduleItemInput: UpdateEventScheduleItemInput;
};


export type MutationUpdateKeyValueArgs = {
  encodedValue: Scalars['String']['input'];
  key: Scalars['String']['input'];
};


export type MutationUpdatePhotoBoothGameCategoryArgs = {
  category: PhotoBoothGameCategoryByIdInput;
  photoBoothGameCategoryInput: UpdatePhotoBoothGameCategoryInput;
};


export type MutationUpdatePhotoBoothGameTaskArgs = {
  photoBoothGameTaskInput: UpdatePhotoBoothGameTaskInput;
  task: PhotoBoothGameTaskByIdInput;
};


export type MutationUpdateServiceProviderDjArgs = {
  serviceProvider: UpdateDj;
  slug: Scalars['String']['input'];
};


export type MutationUpdateServiceProviderLocationArgs = {
  serviceProvider: UpdateLocation;
  slug: Scalars['String']['input'];
};


export type MutationUpdateServiceProviderPhotographerArgs = {
  serviceProvider: UpdatePhotographer;
  slug: Scalars['String']['input'];
};


export type MutationUpdateServiceProviderWeddingFairArgs = {
  serviceProvider: UpdateWeddingFair;
  slug: Scalars['String']['input'];
};


export type MutationUpdateServiceVoucherArgs = {
  serviceVoucher: UpdateServiceVoucherInput;
};


export type MutationUploadEventImageArgs = {
  event: EventByReferenceInput;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadGalleryImageArgs = {
  reference: Scalars['String']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationUploadUserImageArgs = {
  upload: Scalars['Upload']['input'];
};

export type NetPromoter = {
  __typename?: 'NetPromoter';
  /**
   *
   *
   */
  booking: AbstractBooking;
  /**
   *
   *
   */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  reason?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  score: Scalars['Int']['output'];
};

export type NextJsUrl = {
  __typename?: 'NextJsUrl';
  /**
   *
   *
   */
  pathname: Scalars['String']['output'];
};

export type OutboundLinkClicksStatistics = {
  __typename?: 'OutboundLinkClicksStatistics';
  /**
   *
   *
   */
  facebook?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  instagram?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  overallClicks?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pinterest?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  twitter?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  vimeo?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  website?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  youtube?: Maybe<Scalars['Int']['output']>;
};

export type OwnedEventByReferenceInput = {
  reference: Scalars['String']['input'];
};

export type PhotoBoothGameCategory = {
  __typename?: 'PhotoBoothGameCategory';
  /**
   *
   *
   */
  eventTypes: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  internalName?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type PhotoBoothGameCategoryByIdInput = {
  uuid: Scalars['String']['input'];
};

export type PhotoBoothGameTask = {
  __typename?: 'PhotoBoothGameTask';
  /**
   *
   *
   */
  category: PhotoBoothGameCategory;
  /**
   *
   *
   */
  description?: Maybe<Translation>;
  /**
   *
   *
   */
  name: Translation;
  /**
   *
   *
   */
  uuid: Scalars['ID']['output'];
};

export type PhotoBoothGameTaskByIdInput = {
  uuid: Scalars['String']['input'];
};

export type PhotoBoothGameTaskSearch = {
  __typename?: 'PhotoBoothGameTaskSearch';
  /**
   *
   *
   */
  category?: Maybe<PhotoBoothGameCategory>;
  /**
   *
   *
   */
  eventType?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  status?: Maybe<Scalars['String']['output']>;
};

export type PhotoBoothGameTaskSearchInput = {
  category?: InputMaybe<PhotoBoothGameCategoryByIdInput>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type Photographer = AbstractMobileServiceProviderInterface & AbstractServiceProviderInterface & {
  __typename?: 'Photographer';
  /**
   *
   *
   */
  address?: Maybe<Address>;
  /**
   *
   *
   */
  addressValidated?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  addressValidationDisabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  allMedias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  basePrice?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  canReceiveInquiries: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  city?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityForSlug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityUrl: Scalars['String']['output'];
  /**
   *
   *
   */
  claimType?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  company?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactFirstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactLastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  countOfInquiries: Scalars['Int']['output'];
  /**
   *
   *
   */
  countOfOutboundLinks: Scalars['Int']['output'];
  /**
   *
   *
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  creatorRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  creatorUser?: Maybe<User>;
  /**
   *
   *
   */
  criteriaCategories: Array<CriteriaCategoryType>;
  /**
   *
   *
   */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  defaultMedia?: Maybe<ServiceProviderMedia>;
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  disableInquiry: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  facebook?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  hasRatings: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  hasStoppedService: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  highlights: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  images: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  inquiries?: Maybe<Array<ServiceProviderInquiry>>;
  /**
   *
   *
   */
  inquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  instagram?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  intro?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  isClaimRequestAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isClaimed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isInquiryAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isOwnershipDenied: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  links: Array<Link>;
  /**
   *
   *
   */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  maximumTravelDistance?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  medias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  moderationRequired: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  nearbyCities: Array<City>;
  /**
   *
   *
   */
  nearbyServiceProviders: Array<ServiceProviderSearchResult>;
  /**
   *
   *
   */
  noIndex: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  owner?: Maybe<User>;
  /**
   *
   *
   */
  ownerRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  ownerStatus?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  pinterest?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  placeHolderImage?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  premium: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  premiumUntil?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  priceNiveau?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pricePerHour?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pricePerKilometer?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  published: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  ratings?: Maybe<PorpaginasResult_AbstractRatingInterface>;
  /**
   *
   *
   */
  ratingsAverage?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  ratingsCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  ratingsOverview?: Maybe<ServiceProviderRatingOverview>;
  /**
   *
   *
   */
  recommendationRate?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  recommendationsCount?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  showNearbyServiceProviders: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  showOnlyForAdmin?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  showRaffle: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  state?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  statistics?: Maybe<Array<KeyValueType>>;
  /**
   *
   *
   */
  stoppedServiceAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  street1?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  street2?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  structuredData: Scalars['String']['output'];
  /**
   *
   *
   */
  twitter?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  type: Scalars['String']['output'];
  /**
   *
   *
   */
  unansweredInquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  url?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  verified?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  viewedBy?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  vimeo?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  website?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  weeksForImageEditing?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  youtube?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  zip?: Maybe<Scalars['String']['output']>;
};


export type PhotographerCanonicalUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type PhotographerCityUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type PhotographerNearbyServiceProvidersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PhotographerRating = AbstractRatingInterface & {
  __typename?: 'PhotographerRating';
  /**
   *
   *
   */
  allowedToTakePartInRaffle: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  average: Scalars['Float']['output'];
  /**
   *
   *
   */
  bridalTickets?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  event?: Maybe<Event>;
  /**
   *
   *
   */
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  flexibility?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  isArchived: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  overallImpression?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pax?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  price?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  pricePerformanceRatio?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  professionalism?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  qualityOfService?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  recommendation?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  responsiveness?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  reviewerIsBridalCouple: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  reviewerRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  reviewerTickets?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  setAverage: AbstractRatingInterface;
  /**
   *
   *
   */
  supplierType?: Maybe<Array<Scalars['String']['output']>>;
  /**
   *
   *
   */
  terms?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  title?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  totalCostWedding?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  user?: Maybe<User>;
};


export type PhotographerRatingSetAverageArgs = {
  average: Scalars['Float']['input'];
};

export type PorpaginasResult_AbstractRatingInterface = {
  __typename?: 'PorpaginasResult_AbstractRatingInterface';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']['output']>;
  items: Array<AbstractRatingInterface>;
};


export type PorpaginasResult_AbstractRatingInterfaceItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PorpaginasResult_AbstractServiceProviderInterface = {
  __typename?: 'PorpaginasResult_AbstractServiceProviderInterface';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']['output']>;
  items: Array<AbstractServiceProviderInterface>;
};


export type PorpaginasResult_AbstractServiceProviderInterfaceItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PorpaginasResult_Activity = {
  __typename?: 'PorpaginasResult_Activity';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']['output']>;
  items: Array<Activity>;
};


export type PorpaginasResult_ActivityItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PorpaginasResult_AffiliateProgram = {
  __typename?: 'PorpaginasResult_AffiliateProgram';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']['output']>;
  items: Array<AffiliateProgram>;
};


export type PorpaginasResult_AffiliateProgramItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PorpaginasResult_City = {
  __typename?: 'PorpaginasResult_City';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']['output']>;
  items: Array<City>;
};


export type PorpaginasResult_CityItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PorpaginasResult_ClaimRequest = {
  __typename?: 'PorpaginasResult_ClaimRequest';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']['output']>;
  items: Array<ClaimRequest>;
};


export type PorpaginasResult_ClaimRequestItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PorpaginasResult_EventScheduleItem = {
  __typename?: 'PorpaginasResult_EventScheduleItem';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']['output']>;
  items: Array<EventScheduleItem>;
};


export type PorpaginasResult_EventScheduleItemItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PorpaginasResult_EventTaskToUser = {
  __typename?: 'PorpaginasResult_EventTaskToUser';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']['output']>;
  items: Array<EventTaskToUser>;
};


export type PorpaginasResult_EventTaskToUserItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PorpaginasResult_Message = {
  __typename?: 'PorpaginasResult_Message';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']['output']>;
  items: Array<Message>;
};


export type PorpaginasResult_MessageItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PorpaginasResult_PhotoBoothGameCategory = {
  __typename?: 'PorpaginasResult_PhotoBoothGameCategory';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']['output']>;
  items: Array<PhotoBoothGameCategory>;
};


export type PorpaginasResult_PhotoBoothGameCategoryItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PorpaginasResult_PhotoBoothGameTask = {
  __typename?: 'PorpaginasResult_PhotoBoothGameTask';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']['output']>;
  items: Array<PhotoBoothGameTask>;
};


export type PorpaginasResult_PhotoBoothGameTaskItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PorpaginasResult_ServiceVoucher = {
  __typename?: 'PorpaginasResult_ServiceVoucher';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']['output']>;
  items: Array<ServiceVoucher>;
};


export type PorpaginasResult_ServiceVoucherItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PorpaginasResult_User = {
  __typename?: 'PorpaginasResult_User';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']['output']>;
  items: Array<User>;
};


export type PorpaginasResult_UserItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /**
   *
   *
   */
  accessibleEvents: Array<UserToEvent>;
  /**
   *
   *
   */
  activityStream: PorpaginasResult_Activity;
  /**
   *
   *
   */
  affiliatePrograms: PorpaginasResult_AffiliateProgram;
  /**
   *
   *
   */
  affiliateStatistics: AffiliateStatistics;
  /**
   *
   *
   */
  affiliateUsers: PorpaginasResult_User;
  /**
   *
   *
   */
  cities: PorpaginasResult_City;
  /**
   *
   *
   */
  city: City;
  /**
   *
   *
   */
  claimRequestsToSend: PorpaginasResult_ClaimRequest;
  /**
   *
   *
   */
  createPresignedUploadUrlForFile?: Maybe<Image>;
  /**
   *
   *
   */
  criteriaCategories: Array<CriteriaCategoryType>;
  /**
   *
   *
   */
  currentUser?: Maybe<User>;
  /**
   *
   *
   */
  event: EventResponse;
  /**
   *
   *
   */
  eventImageUploadUrl: Scalars['String']['output'];
  /**
   *
   *
   */
  eventScheduleItemByEvent: PorpaginasResult_EventScheduleItem;
  /**
   *
   *
   */
  imageComments: Array<ImageComment>;
  /**
   *
   *
   */
  imageDetailsByEventReferenceAndImage: Image;
  /**
   *
   *
   */
  imageLikeCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  imagesByEventReference: UserToEvent;
  /**
   *
   *
   */
  likedImagesForEvent: Array<Image>;
  /**
   *
   *
   */
  linkedDevices: Array<UserMobileDevice>;
  /**
   *
   *
   */
  listKeyValues: Array<KeyValue>;
  /**
   *
   *
   */
  markets: Markets;
  /**
   *
   *
   */
  me?: Maybe<SymfonyUserInterface>;
  /**
   *
   *
   */
  messageConversation: PorpaginasResult_Message;
  /**
   *
   *
   */
  myTasks: PorpaginasResult_EventTaskToUser;
  /**
   *
   *
   */
  parentMessages: PorpaginasResult_Message;
  /**
   *
   *
   */
  photoBoothGameCategories: PorpaginasResult_PhotoBoothGameCategory;
  /**
   *
   *
   */
  photoBoothGameTasks: PorpaginasResult_PhotoBoothGameTask;
  /**
   *
   *
   */
  photoBoothGameTasksByEvent: PorpaginasResult_PhotoBoothGameTask;
  /**
   *
   *
   */
  presignedUrlByImageAndEvent: Image;
  /**
   *
   *
   */
  serviceProvider: AbstractServiceProviderInterface;
  /**
   *
   *
   */
  serviceProviderRedirect: AbstractServiceProviderInterface;
  /**
   *
   *
   */
  serviceProviderStatistics: ServiceProviderStatistics;
  /**
   *
   *
   */
  serviceProviderTypeSettings: ServiceProviderTypeSettings;
  /**
   *
   *
   */
  serviceProviders: PorpaginasResult_AbstractServiceProviderInterface;
  /**
   *
   *
   */
  serviceVoucher: ServiceVoucher;
  /**
   *
   *
   */
  serviceVouchers: PorpaginasResult_ServiceVoucher;
  /**
   *
   *
   */
  services: Array<Service>;
  /**
   *
   *
   */
  userProfileImageUploadUrl: Scalars['String']['output'];
  /**
   *
   *
   */
  users: PorpaginasResult_User;
  /**
   *
   *
   */
  usersByEvent: Array<UserToEvent>;
};


export type QueryActivityStreamArgs = {
  context: Scalars['String']['input'];
};


export type QueryAffiliateStatisticsArgs = {
  configuration?: InputMaybe<AffiliateStatisticsInput>;
};


export type QueryAffiliateUsersArgs = {
  search?: InputMaybe<AffiliateSearchInput>;
};


export type QueryCitiesArgs = {
  hasCityPage?: InputMaybe<Scalars['Boolean']['input']>;
  hasContent?: InputMaybe<Scalars['Boolean']['input']>;
  marketKey?: InputMaybe<Scalars['String']['input']>;
  searchWord?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCityArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCreatePresignedUploadUrlForFileArgs = {
  creationDateString?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};


export type QueryCriteriaCategoriesArgs = {
  type: Scalars['String']['input'];
};


export type QueryEventArgs = {
  event: EventByReferenceInput;
};


export type QueryEventImageUploadUrlArgs = {
  event: EventByReferenceInput;
  filename: Scalars['String']['input'];
};


export type QueryEventScheduleItemByEventArgs = {
  reference: Scalars['String']['input'];
};


export type QueryImageCommentsArgs = {
  imageId: Scalars['Int']['input'];
};


export type QueryImageDetailsByEventReferenceAndImageArgs = {
  imageId: Scalars['Int']['input'];
  reference: Scalars['String']['input'];
};


export type QueryImageLikeCountArgs = {
  imageId: Scalars['Int']['input'];
};


export type QueryImagesByEventReferenceArgs = {
  reference: Scalars['String']['input'];
};


export type QueryLikedImagesForEventArgs = {
  reference: Scalars['String']['input'];
};


export type QueryMessageConversationArgs = {
  parentMessage: MessageByUuidInput;
};


export type QueryMyTasksArgs = {
  event: EventForGuestByReferenceInput;
};


export type QueryPhotoBoothGameTasksArgs = {
  search?: InputMaybe<PhotoBoothGameTaskSearchInput>;
};


export type QueryPhotoBoothGameTasksByEventArgs = {
  reference: Scalars['String']['input'];
};


export type QueryPresignedUrlByImageAndEventArgs = {
  imageId: Scalars['Int']['input'];
  reference: Scalars['String']['input'];
};


export type QueryServiceProviderArgs = {
  ignoreIfIsPublished?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryServiceProviderRedirectArgs = {
  slug: Scalars['String']['input'];
};


export type QueryServiceProviderStatisticsArgs = {
  configuration?: InputMaybe<ServiceProviderStatisticsInput>;
};


export type QueryServiceProviderTypeSettingsArgs = {
  type: Scalars['String']['input'];
};


export type QueryServiceProvidersArgs = {
  search?: InputMaybe<ServiceProviderSearchInput>;
};


export type QueryServiceVoucherArgs = {
  serviceVoucher: ServiceVoucherRefInput;
};


export type QueryServiceVouchersArgs = {
  search?: InputMaybe<ServiceVoucherSearchInput>;
};


export type QueryUserProfileImageUploadUrlArgs = {
  filename: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  isServiceProviderOwner?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsersByEventArgs = {
  ignoreBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  reference: Scalars['String']['input'];
};

export type RatingByIdAndTypeInput = {
  type: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type RatingMedia = {
  __typename?: 'RatingMedia';
  /**
   *
   *
   */
  file: Scalars['String']['output'];
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  paths: Array<Link>;
  /**
   *
   *
   */
  uploaderFirstName: Scalars['String']['output'];
  /**
   *
   *
   */
  uploaderLastName: Scalars['String']['output'];
};


export type RatingMediaUploaderLastNameArgs = {
  showFull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RatingMediaView = {
  __typename?: 'RatingMediaView';
  /**
   *
   *
   */
  file: Scalars['String']['output'];
  /**
   *
   *
   */
  paths: Array<Link>;
  /**
   *
   *
   */
  type: Scalars['String']['output'];
  /**
   *
   *
   */
  uploaderFirstName?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  uploaderLastName?: Maybe<Scalars['String']['output']>;
};

export type RatingMutationResponse = {
  __typename?: 'RatingMutationResponse';
  /**
   *
   *
   *
   */
  message: Scalars['String']['output'];
  /**
   *
   *
   *
   */
  ratingId: Scalars['String']['output'];
  /**
   *
   *
   *
   */
  success: Scalars['Boolean']['output'];
};

export type RegistryOffice = {
  __typename?: 'RegistryOffice';
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  url: Scalars['String']['output'];
};

export type RequestLoginTokenResult = {
  __typename?: 'RequestLoginTokenResult';
  /**
   *
   *
   */
  loginWithPasswordPossible: Scalars['Boolean']['output'];
};

export type Search = {
  __typename?: 'Search';
  /**
   *
   *
   *
   */
  categoriesIds: Array<Scalars['Int']['output']>;
  /**
   *
   *
   */
  city?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  distance?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  forWebsite?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  isSupport?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  minimumRating?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  ownerSearchTerm?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  serviceProvider?: Maybe<AbstractServiceProviderInterface>;
  /**
   *
   *
   */
  serviceProviderType?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   *
   */
  slugs: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  state?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  status?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  weeks?: Maybe<Scalars['Int']['output']>;
};

export type Service = {
  __typename?: 'Service';
  /**
   *
   *
   */
  cartKeyFactCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  conversionTags: MarketConfiguration;
  /**
   *
   *
   */
  hasEvent: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isAvailable: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isVoucherAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  nameInternal: Scalars['String']['output'];
  /**
   *
   *
   */
  paymentConfirmationDocumentType?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  serviceConfigurationSlug: Scalars['String']['output'];
  /**
   *
   *
   */
  slug: Scalars['String']['output'];
  /**
   *
   *
   */
  sorting: Scalars['Int']['output'];
  /**
   *
   *
   */
  templateFiles: Array<KeyValueType>;
  /**
   *
   *
   */
  translations: ServiceTranslation;
};

export type ServiceProviderBySlugInput = {
  slug: Scalars['String']['input'];
};

export type ServiceProviderInquiry = {
  __typename?: 'ServiceProviderInquiry';
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  email: Scalars['String']['output'];
  /**
   *
   *
   */
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  eventDateUnknown: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  eventRangeDateFrom?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  eventRangeDateTo?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  eventType: Scalars['String']['output'];
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  pax?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  sendEmailToRequester: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  serviceProvider?: Maybe<AbstractServiceProviderInterface>;
  /**
   *
   *
   */
  setFirstname: ServiceProviderInquiry;
  /**
   *
   *
   */
  text?: Maybe<Scalars['String']['output']>;
};


export type ServiceProviderInquirySetFirstnameArgs = {
  firstname?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceProviderInquiryOffer = {
  __typename?: 'ServiceProviderInquiryOffer';
  /**
   *
   *
   */
  accepted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  declined: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isValid: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  message: Message;
  /**
   *
   *
   */
  price: Scalars['Int']['output'];
  /**
   *
   *
   */
  revoked: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  serviceProviderInquiry: ServiceProviderInquiry;
  /**
   *
   *
   */
  serviceProviderInquiryOfferAttachment: Array<ServiceProviderInquiryOfferAttachment>;
  /**
   *
   *
   */
  uuid?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type ServiceProviderInquiryOfferAttachment = {
  __typename?: 'ServiceProviderInquiryOfferAttachment';
  /**
   *
   *
   */
  downloadUrl: Scalars['String']['output'];
  /**
   *
   *
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  serviceProviderInquiryOffer: ServiceProviderInquiryOffer;
  /**
   *
   *
   */
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type ServiceProviderMedia = {
  __typename?: 'ServiceProviderMedia';
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  file?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  officialMedia: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  paths: Array<Link>;
  /**
   *
   *
   */
  serviceProvider?: Maybe<AbstractServiceProviderInterface>;
  /**
   *
   *
   */
  sorting: Scalars['Int']['output'];
  /**
   *
   *
   */
  type?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  uploadedBy?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  url?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  webPath?: Maybe<Scalars['String']['output']>;
};

export type ServiceProviderRatingOverview = {
  __typename?: 'ServiceProviderRatingOverview';
  /**
   *
   *
   */
  average?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  featuresRatingAverage?: Maybe<Array<FeatureStarRating>>;
  /**
   *
   *
   */
  fiveStarsCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  fourStarsCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  oneStarCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  ratingsCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  ratingsImages?: Maybe<Array<RatingMedia>>;
  /**
   *
   *
   */
  threeStarsCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  twoStarsCount: Scalars['Int']['output'];
};

export type ServiceProviderSearchInput = {
  categoriesIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['Int']['input']>;
  forWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isSupport?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  minimumRating?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerSearchTerm?: InputMaybe<Scalars['String']['input']>;
  serviceProvider?: InputMaybe<AbstractServiceProviderInput>;
  serviceProviderType?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  weeks?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceProviderSearchResult = {
  __typename?: 'ServiceProviderSearchResult';
  /**
   *
   *
   */
  city?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  defaultMedia?: Maybe<ServiceProviderMedia>;
  /**
   *
   *
   */
  distance?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  isClaimRequestAllowed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  isClaimed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  priceNiveau?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  ratingsAverage?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  ratingsCount?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  recommendationsCount?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  slug: Scalars['String']['output'];
  /**
   *
   *
   */
  state?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  street1?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  type: Scalars['String']['output'];
  /**
   *
   *
   */
  url?: Maybe<NextJsUrl>;
  /**
   *
   *
   */
  zip?: Maybe<Scalars['String']['output']>;
};


export type ServiceProviderSearchResultUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};

export type ServiceProviderStatistic = {
  __typename?: 'ServiceProviderStatistic';
  /**
   *
   *
   */
  countOfPhotobooths: Scalars['Int']['output'];
  /**
   *
   *
   */
  detailViewsAppearances: Scalars['Int']['output'];
  /**
   *
   *
   */
  featuredViewsAppearances: Scalars['Int']['output'];
  /**
   *
   *
   */
  inquiries: Scalars['Int']['output'];
  /**
   *
   *
   */
  outboundLinkClicks: OutboundLinkClicksStatistics;
  /**
   *
   *
   */
  ratings: Scalars['Int']['output'];
  /**
   *
   *
   */
  searchResultsAppearances: Scalars['Int']['output'];
};

export type ServiceProviderStatistics = {
  __typename?: 'ServiceProviderStatistics';
  /**
   *
   *
   */
  from: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  period?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  search?: Maybe<Search>;
  /**
   *
   *
   */
  setSearch: ServiceProviderStatistics;
  /**
   *
   *
   */
  timeSpan?: Maybe<StatisticsTimeSpan>;
  /**
   *
   *
   */
  timeSpanDescriber?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  to: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  values?: Maybe<Array<Maybe<ServiceProviderStatisticsValue>>>;
};


export type ServiceProviderStatisticsSetSearchArgs = {
  search?: InputMaybe<ServiceProviderSearchInput>;
};

export type ServiceProviderStatisticsInput = {
  period?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<ServiceProviderSearchInput>;
  timeSpan?: InputMaybe<StatisticsTimeSpanInput>;
  timeSpanDescriber?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceProviderStatisticsValue = {
  __typename?: 'ServiceProviderStatisticsValue';
  from: Scalars['DateTime']['output'];
  to: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  value: ServiceProviderStatistic;
};

export type ServiceProviderTypeSettings = {
  __typename?: 'ServiceProviderTypeSettings';
  /**
   *
   *
   */
  criteriaCategories: Array<CriteriaCategoryType>;
  /**
   *
   *
   */
  hasDetailPage: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  hasRating: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isForEvent: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isInquiryAllowed: Scalars['Boolean']['output'];
};

export type ServiceTranslatable = {
  __typename?: 'ServiceTranslatable';
  /**
   *
   *
   */
  intro?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  link?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  name?: Maybe<Scalars['String']['output']>;
};

export type ServiceTranslation = {
  __typename?: 'ServiceTranslation';
  /**
   *
   *
   */
  da?: Maybe<ServiceTranslatable>;
  /**
   *
   *
   */
  de?: Maybe<ServiceTranslatable>;
  /**
   *
   *
   */
  en?: Maybe<ServiceTranslatable>;
  /**
   *
   *
   */
  es?: Maybe<ServiceTranslatable>;
  /**
   *
   *
   */
  fr?: Maybe<ServiceTranslatable>;
  /**
   *
   *
   */
  it?: Maybe<ServiceTranslatable>;
  /**
   *
   *
   */
  nl?: Maybe<ServiceTranslatable>;
  /**
   *
   *
   */
  pl?: Maybe<ServiceTranslatable>;
};

export type ServiceVoucher = {
  __typename?: 'ServiceVoucher';
  /**
   *
   *
   */
  amount: Scalars['Int']['output'];
  /**
   *
   *
   */
  bookingDateFrom?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  bookingDateTo?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  bookings?: Maybe<Array<Maybe<CartBooking>>>;
  /**
   *
   *
   */
  code: Scalars['String']['output'];
  /**
   *
   *
   */
  codeCanonicalized?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  configuration: ServiceVoucherConfiguration;
  /**
   *
   *
   */
  hasLimit: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  inquiries?: Maybe<Array<Maybe<CartInquiry>>>;
  /**
   *
   *
   */
  isActive: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isAllowedOnAdditionalCarts: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isAutomaticVoucher: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isInfluencerVoucher: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  numberOfMaxUsages: Scalars['Int']['output'];
  /**
   *
   *
   */
  numberOfUsages: Scalars['Int']['output'];
  /**
   *
   *
   */
  predecessorCode: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  products?: Maybe<Array<Maybe<ServiceVoucherProduct>>>;
  /**
   *
   *
   */
  services: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  successor?: Maybe<ServiceVoucher>;
  /**
   *
   *
   */
  translations: ServiceVoucherTranslation;
  /**
   *
   *
   */
  validFrom: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  validTo: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  valueType?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  voucherType?: Maybe<Scalars['String']['output']>;
};

export type ServiceVoucherByCodeRefInput = {
  code: Scalars['String']['input'];
};

export type ServiceVoucherConfiguration = {
  __typename?: 'ServiceVoucherConfiguration';
  /**
   *
   *
   */
  isAbleToMarkCartAsPaid: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  markets: MarketActivation;
};

export type ServiceVoucherProduct = {
  __typename?: 'ServiceVoucherProduct';
  /**
   *
   *
   */
  amount: Scalars['Int']['output'];
  /**
   *
   *
   */
  productId: Scalars['Int']['output'];
};

export type ServiceVoucherProductInput = {
  amount: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
};

export type ServiceVoucherRefInput = {
  id: Scalars['Int']['input'];
};

export type ServiceVoucherSearchInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
  voucherType?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceVoucherTranslatable = {
  __typename?: 'ServiceVoucherTranslatable';
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  name?: Maybe<Scalars['String']['output']>;
};

export type ServiceVoucherTranslatableInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceVoucherTranslation = {
  __typename?: 'ServiceVoucherTranslation';
  /**
   *
   *
   */
  da?: Maybe<ServiceVoucherTranslatable>;
  /**
   *
   *
   */
  de?: Maybe<ServiceVoucherTranslatable>;
  /**
   *
   *
   */
  en?: Maybe<ServiceVoucherTranslatable>;
  /**
   *
   *
   */
  es?: Maybe<ServiceVoucherTranslatable>;
  /**
   *
   *
   */
  fr?: Maybe<ServiceVoucherTranslatable>;
  /**
   *
   *
   */
  it?: Maybe<ServiceVoucherTranslatable>;
  /**
   *
   *
   */
  nl?: Maybe<ServiceVoucherTranslatable>;
  /**
   *
   *
   */
  pl?: Maybe<ServiceVoucherTranslatable>;
};

export type ServiceVoucherTranslationsInput = {
  da?: InputMaybe<ServiceVoucherTranslatableInput>;
  de?: InputMaybe<ServiceVoucherTranslatableInput>;
  en?: InputMaybe<ServiceVoucherTranslatableInput>;
  es?: InputMaybe<ServiceVoucherTranslatableInput>;
  fr?: InputMaybe<ServiceVoucherTranslatableInput>;
  it?: InputMaybe<ServiceVoucherTranslatableInput>;
  nl?: InputMaybe<ServiceVoucherTranslatableInput>;
  pl?: InputMaybe<ServiceVoucherTranslatableInput>;
};

export type State = {
  __typename?: 'State';
  /**
   *
   *
   */
  key: Scalars['String']['output'];
  /**
   *
   *
   */
  name: Translation;
};

export type Statistics = {
  __typename?: 'Statistics';
  /**
   *
   *
   */
  from: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  period: Scalars['String']['output'];
  /**
   *
   *
   */
  to: Scalars['DateTime']['output'];
  /**
   *
   *
   *
   */
  values: Array<StatisticsValue>;
};

export type StatisticsTimeSpan = {
  __typename?: 'StatisticsTimeSpan';
  /**
   *
   *
   */
  from?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type StatisticsTimeSpanInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StatisticsValue = {
  __typename?: 'StatisticsValue';
  /**
   *
   *
   */
  from: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  to: Scalars['DateTime']['output'];
};

export type SymfonyUserImpl = SymfonyUserInterface & {
  __typename?: 'SymfonyUserImpl';
  /**
   *
   *
   */
  roles: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  userName: Scalars['String']['output'];
};

export type SymfonyUserInterface = {
  /**
   *
   *
   */
  roles: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  userName: Scalars['String']['output'];
};

export type TextReplacement = {
  __typename?: 'TextReplacement';
  /**
   *
   *
   */
  replacement: Scalars['String']['output'];
  /**
   *
   *
   */
  text: Scalars['String']['output'];
};

export type Translation = {
  __typename?: 'Translation';
  /**
   *
   *
   */
  da?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  de?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  en?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  es?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  fr?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  it?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  nl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  pl?: Maybe<Scalars['String']['output']>;
};

export type TranslationInput = {
  da?: InputMaybe<Scalars['String']['input']>;
  de?: InputMaybe<Scalars['String']['input']>;
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  it?: InputMaybe<Scalars['String']['input']>;
  nl?: InputMaybe<Scalars['String']['input']>;
  pl?: InputMaybe<Scalars['String']['input']>;
};

export type User = SymfonyUserInterface & {
  __typename?: 'User';
  /**
   *
   *
   */
  appCity?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  appCountry?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  appLatitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  appLongitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  birthday?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  email: Scalars['String']['output'];
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   * Gets id
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  initials: Scalars['String']['output'];
  /**
   *
   *
   */
  isDeleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  language?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  market?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  profileImage?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  profileImageDetail?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  refreshToken: Scalars['String']['output'];
  /**
   *
   *
   */
  registrationScope?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  roles: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  userName: Scalars['String']['output'];
};


export type UserProfileImageDetailArgs = {
  transformation?: InputMaybe<Scalars['String']['input']>;
};

export type UserAnonymous = {
  __typename?: 'UserAnonymous';
  /**
   *
   *
   */
  appCity?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  appCountry?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  appLatitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  appLongitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  birthday?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  email: Scalars['String']['output'];
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   * Gets id
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  initials: Scalars['String']['output'];
  /**
   *
   *
   */
  isDeleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  language?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  market?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  profileImage?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  profileImageDetail?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  refreshToken: Scalars['String']['output'];
  /**
   *
   *
   */
  registrationScope?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  roles: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  userName: Scalars['String']['output'];
};


export type UserAnonymousProfileImageDetailArgs = {
  transformation?: InputMaybe<Scalars['String']['input']>;
};

export type UserByIdInput = {
  id: Scalars['Int']['input'];
};

export type UserMobileDevice = {
  __typename?: 'UserMobileDevice';
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  deviceToken: Scalars['String']['output'];
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  user: User;
};

export type UserRegistration = {
  __typename?: 'UserRegistration';
  /**
   *
   *
   */
  appCity?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  appCountry?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  appLatitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  appLongitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  birthday?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  email: Scalars['String']['output'];
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   * Gets id
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  initials: Scalars['String']['output'];
  /**
   *
   *
   */
  isDeleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  language?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  market?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  profileImage?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  profileImageDetail?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  refreshToken: Scalars['String']['output'];
  /**
   *
   *
   */
  registrationScope?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  roles: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  token: Scalars['String']['output'];
  /**
   *
   *
   */
  userName: Scalars['String']['output'];
};


export type UserRegistrationProfileImageDetailArgs = {
  transformation?: InputMaybe<Scalars['String']['input']>;
};

export type UserToEvent = {
  __typename?: 'UserToEvent';
  /**
   *
   *
   */
  blocked: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  event: Event;
  /**
   *
   *
   */
  galleryImages: Array<Image>;
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  role: UserToEventRole;
  /**
   *
   *
   */
  user: User;
};


export type UserToEventGalleryImagesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

export type UserToEventRole = {
  __typename?: 'UserToEventRole';
  /**
   *
   *
   */
  hierarchy: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  name: Scalars['String']['output'];
};

export type UserToServiceProvider = {
  __typename?: 'UserToServiceProvider';
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  id: Scalars['ID']['output'];
  /**
   *
   *
   */
  role?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  serviceProvider?: Maybe<AbstractServiceProviderInterface>;
  /**
   *
   *
   */
  user: User;
};

export type UserView = {
  __typename?: 'UserView';
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  language?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  profileImage?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  profileImageDetail?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  registrationScope?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  token?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type WeddingFair = AbstractServiceProviderInterface & {
  __typename?: 'WeddingFair';
  /**
   *
   *
   */
  address?: Maybe<Address>;
  /**
   *
   *
   */
  addressValidated?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  addressValidationDisabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  allMedias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  area?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  canReceiveInquiries: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  city?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityForSlug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  cityUrl: Scalars['String']['output'];
  /**
   *
   *
   */
  claimType?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  company?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactFirstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  contactLastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  countOfInquiries: Scalars['Int']['output'];
  /**
   *
   *
   */
  countOfOutboundLinks: Scalars['Int']['output'];
  /**
   *
   *
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  creatorRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  creatorUser?: Maybe<User>;
  /**
   *
   *
   */
  criteriaCategories: Array<CriteriaCategoryType>;
  /**
   *
   *
   */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  defaultMedia?: Maybe<ServiceProviderMedia>;
  /**
   *
   *
   */
  deleted: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  disableInquiry: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  facebook?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  fromDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  hasRatings: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  hasStoppedService: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  highlights: Array<Scalars['String']['output']>;
  /**
   *
   *
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   *
   *
   */
  images: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  inquiries?: Maybe<Array<ServiceProviderInquiry>>;
  /**
   *
   *
   */
  inquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  instagram?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  intro?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  isClaimRequestAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isClaimed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isInquiryAllowed: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  isOwnershipDenied: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  links: Array<Link>;
  /**
   *
   *
   */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  medias: Array<ServiceProviderMedia>;
  /**
   *
   *
   */
  moderationRequired: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  name: Scalars['String']['output'];
  /**
   *
   *
   */
  nearbyCities: Array<City>;
  /**
   *
   *
   */
  nearbyServiceProviders: Array<ServiceProviderSearchResult>;
  /**
   *
   *
   */
  noIndex: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  notTakingPlace?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  numberOfSuppliers?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  owner?: Maybe<User>;
  /**
   *
   *
   */
  ownerRole?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  ownerStatus?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  pinterest?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  placeHolderImage?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  premium: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  premiumUntil?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  priceNiveau?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  published: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  ratings?: Maybe<PorpaginasResult_AbstractRatingInterface>;
  /**
   *
   *
   */
  ratingsAverage?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  ratingsCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  ratingsOverview?: Maybe<ServiceProviderRatingOverview>;
  /**
   *
   *
   */
  recommendationRate?: Maybe<Scalars['Float']['output']>;
  /**
   *
   *
   */
  recommendationsCount?: Maybe<Scalars['Int']['output']>;
  /**
   *
   *
   */
  showNearbyServiceProviders: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  showOnlyForAdmin?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  showRaffle: Scalars['Boolean']['output'];
  /**
   *
   *
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  state?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  statistics?: Maybe<Array<KeyValueType>>;
  /**
   *
   *
   */
  stoppedServiceAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  street1?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  street2?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  structuredData: Scalars['String']['output'];
  /**
   *
   *
   */
  telefax?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  ticket?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  ticketVVK?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  toDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  twitter?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  type: Scalars['String']['output'];
  /**
   *
   *
   */
  unansweredInquiryCount: Scalars['Int']['output'];
  /**
   *
   *
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   *
   *
   */
  url?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  verified?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewed?: Maybe<Scalars['Boolean']['output']>;
  /**
   *
   *
   */
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *
   */
  viewedBy?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  vimeo?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  website?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  youtube?: Maybe<Scalars['String']['output']>;
  /**
   *
   *
   */
  zip?: Maybe<Scalars['String']['output']>;
};


export type WeddingFairCanonicalUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type WeddingFairCityUrlArgs = {
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type WeddingFairNearbyServiceProvidersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAddress = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
  validationDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDj = {
  address?: InputMaybe<CreateAddress>;
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  contactFirstname?: InputMaybe<Scalars['String']['input']>;
  contactLastname?: InputMaybe<Scalars['String']['input']>;
  creatorRole?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  equipmentPriceFor50Pax?: InputMaybe<Scalars['Int']['input']>;
  equipmentPriceFor100Pax?: InputMaybe<Scalars['Int']['input']>;
  equipmentPriceFor150Pax?: InputMaybe<Scalars['Int']['input']>;
  equipmentPriceFor250Pax?: InputMaybe<Scalars['Int']['input']>;
  equipmentPriceFor500Pax?: InputMaybe<Scalars['Int']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  maximumTravelDistance?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  premiumUntil?: InputMaybe<Scalars['DateTime']['input']>;
  pricePerHour?: InputMaybe<Scalars['Int']['input']>;
  pricePerKilometer?: InputMaybe<Scalars['Int']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  vimeo?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEventScheduleItemInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  event?: InputMaybe<EventByReferenceInput>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  isInEventLocation?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  startAt: Scalars['DateTime']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEventTaskInput = {
  allGuestsNeedToDoIt?: Scalars['Boolean']['input'];
  event: EventByReferenceInput;
  freeText: Scalars['String']['input'];
  numberOfGuests: Scalars['Int']['input'];
  photoBoothGameTask: CreatePhotoBoothGameTaskInput;
};

export type CreateFeedback = {
  source: Scalars['String']['input'];
  text: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLocation = {
  accommodationAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  accommodationIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  accommodationPax?: InputMaybe<Scalars['Int']['input']>;
  accommodationPrice?: InputMaybe<Scalars['Int']['input']>;
  accommodationRentMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<CreateAddress>;
  cateringCookingStyle?: InputMaybe<Scalars['String']['input']>;
  cateringExternalAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  cateringFromLocation?: InputMaybe<Scalars['Boolean']['input']>;
  cateringPriceMin?: InputMaybe<Scalars['Int']['input']>;
  cateringType?: InputMaybe<Scalars['String']['input']>;
  contactFirstname?: InputMaybe<Scalars['String']['input']>;
  contactLastname?: InputMaybe<Scalars['String']['input']>;
  countOfRooms?: InputMaybe<Scalars['Int']['input']>;
  creatorRole?: InputMaybe<Scalars['String']['input']>;
  curfew?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  drinksAvailableDrinks?: InputMaybe<Scalars['String']['input']>;
  drinksExternalAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  drinksFromLocation?: InputMaybe<Scalars['Boolean']['input']>;
  drinksPriceModel?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  emptyRoom?: InputMaybe<Scalars['Boolean']['input']>;
  exclusiveRentalPossible?: InputMaybe<Scalars['Boolean']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  openEnd?: InputMaybe<Scalars['Boolean']['input']>;
  outsideAreaAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  parkingAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  paxMax?: InputMaybe<Scalars['Int']['input']>;
  paxMin?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  premiumUntil?: InputMaybe<Scalars['DateTime']['input']>;
  roomRentPrice?: InputMaybe<Scalars['Int']['input']>;
  roomRentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  seatingForm?: InputMaybe<Scalars['String']['input']>;
  servicePersonnelExternalAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  servicePersonnelFromLocation?: InputMaybe<Scalars['Boolean']['input']>;
  sizeOfRooms?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  vimeo?: InputMaybe<Scalars['String']['input']>;
  volumeLimit?: InputMaybe<Scalars['Boolean']['input']>;
  volumeLimitMaxDecibel?: InputMaybe<Scalars['Int']['input']>;
  volumeLimitTime?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePhotoBoothGameCategoryInput = {
  eventTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName: Scalars['String']['input'];
};

export type CreatePhotoBoothGameTaskInput = {
  category: PhotoBoothGameCategoryByIdInput;
  description?: InputMaybe<TranslationInput>;
  name: TranslationInput;
  translateText?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreatePhotographer = {
  address?: InputMaybe<CreateAddress>;
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  contactFirstname?: InputMaybe<Scalars['String']['input']>;
  contactLastname?: InputMaybe<Scalars['String']['input']>;
  creatorRole?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  maximumTravelDistance?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  premiumUntil?: InputMaybe<Scalars['DateTime']['input']>;
  pricePerHour?: InputMaybe<Scalars['Int']['input']>;
  pricePerKilometer?: InputMaybe<Scalars['Int']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  vimeo?: InputMaybe<Scalars['String']['input']>;
  weeksForImageEditing?: InputMaybe<Scalars['Int']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type CreateServiceProviderInquiryOfferInput = {
  content: Scalars['String']['input'];
  inquiryMessage: MessageByUuidInput;
  price: Scalars['Int']['input'];
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateServiceVoucherConfiguration = {
  isAbleToMarkCartAsPaid?: InputMaybe<Scalars['Boolean']['input']>;
  markets?: InputMaybe<MarketChoiceInput>;
};

export type CreateServiceVoucherInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  bookingDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  bookingDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  code: Scalars['String']['input'];
  configuration?: InputMaybe<CreateServiceVoucherConfiguration>;
  isActive: Scalars['Boolean']['input'];
  isUpgradeVoucher?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfMaxUsages: Scalars['Int']['input'];
  products?: InputMaybe<Array<InputMaybe<ServiceVoucherProductInput>>>;
  services?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successor?: InputMaybe<ServiceVoucherByCodeRefInput>;
  translations?: InputMaybe<ServiceVoucherTranslationsInput>;
  validFrom: Scalars['DateTime']['input'];
  validTo: Scalars['DateTime']['input'];
  valueType?: InputMaybe<Scalars['String']['input']>;
  voucherType: Scalars['String']['input'];
};

export type CreateUser = {
  affiliateProgram?: InputMaybe<Scalars['Int']['input']>;
  appCity?: InputMaybe<Scalars['String']['input']>;
  appCountry?: InputMaybe<Scalars['String']['input']>;
  appLatitude?: InputMaybe<Scalars['Float']['input']>;
  appLongitude?: InputMaybe<Scalars['Float']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  eventDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventTitle?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  fok?: InputMaybe<Scalars['String']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  market: Scalars['String']['input'];
  partnerKey?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  registrationScope: Scalars['String']['input'];
  requestToken?: InputMaybe<Scalars['Boolean']['input']>;
  tokenLogin?: InputMaybe<Scalars['Boolean']['input']>;
  usedInPhotoApp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateWeddingFair = {
  address?: InputMaybe<CreateAddress>;
  area?: InputMaybe<Scalars['Float']['input']>;
  contactFirstname?: InputMaybe<Scalars['String']['input']>;
  contactLastname?: InputMaybe<Scalars['String']['input']>;
  creatorRole?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  facebook?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notTakingPlace?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfSuppliers?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  premiumUntil?: InputMaybe<Scalars['DateTime']['input']>;
  telefax?: InputMaybe<Scalars['String']['input']>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketVVK?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  vimeo?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveServiceVoucherFromCarts = {
  id: Scalars['Int']['input'];
};

export type UpdateDj = {
  address?: InputMaybe<CreateAddress>;
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  contactFirstname?: InputMaybe<Scalars['String']['input']>;
  contactLastname?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disableInquiry?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  equipmentPriceFor50Pax?: InputMaybe<Scalars['Int']['input']>;
  equipmentPriceFor100Pax?: InputMaybe<Scalars['Int']['input']>;
  equipmentPriceFor150Pax?: InputMaybe<Scalars['Int']['input']>;
  equipmentPriceFor250Pax?: InputMaybe<Scalars['Int']['input']>;
  equipmentPriceFor500Pax?: InputMaybe<Scalars['Int']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  maximumTravelDistance?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  premiumUntil?: InputMaybe<Scalars['DateTime']['input']>;
  pricePerHour?: InputMaybe<Scalars['Int']['input']>;
  pricePerKilometer?: InputMaybe<Scalars['Int']['input']>;
  showOnlyForAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
  vimeo?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventInput = {
  eventType?: InputMaybe<Scalars['String']['input']>;
  inPrivateLocation?: InputMaybe<Scalars['Boolean']['input']>;
  noDj?: InputMaybe<Scalars['Boolean']['input']>;
  noPhotographer?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventScheduleItemInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  isInEventLocation?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLocation = {
  accommodationAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  accommodationIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  accommodationPax?: InputMaybe<Scalars['Int']['input']>;
  accommodationPrice?: InputMaybe<Scalars['Int']['input']>;
  accommodationRentMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<CreateAddress>;
  cateringCookingStyle?: InputMaybe<Scalars['String']['input']>;
  cateringExternalAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  cateringFromLocation?: InputMaybe<Scalars['Boolean']['input']>;
  cateringPriceMin?: InputMaybe<Scalars['Int']['input']>;
  cateringType?: InputMaybe<Scalars['String']['input']>;
  contactFirstname?: InputMaybe<Scalars['String']['input']>;
  contactLastname?: InputMaybe<Scalars['String']['input']>;
  countOfRooms?: InputMaybe<Scalars['Int']['input']>;
  curfew?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disableInquiry?: InputMaybe<Scalars['Boolean']['input']>;
  drinksAvailableDrinks?: InputMaybe<Scalars['String']['input']>;
  drinksExternalAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  drinksFromLocation?: InputMaybe<Scalars['Boolean']['input']>;
  drinksPriceModel?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emptyRoom?: InputMaybe<Scalars['Boolean']['input']>;
  exclusiveRentalPossible?: InputMaybe<Scalars['Boolean']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openEnd?: InputMaybe<Scalars['Boolean']['input']>;
  outsideAreaAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  parkingAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  paxMax?: InputMaybe<Scalars['Int']['input']>;
  paxMin?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  premiumUntil?: InputMaybe<Scalars['DateTime']['input']>;
  roomRentPrice?: InputMaybe<Scalars['Int']['input']>;
  roomRentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  seatingForm?: InputMaybe<Scalars['String']['input']>;
  servicePersonnelExternalAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  servicePersonnelFromLocation?: InputMaybe<Scalars['Boolean']['input']>;
  showOnlyForAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  sizeOfRooms?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
  vimeo?: InputMaybe<Scalars['String']['input']>;
  volumeLimit?: InputMaybe<Scalars['Boolean']['input']>;
  volumeLimitMaxDecibel?: InputMaybe<Scalars['Int']['input']>;
  volumeLimitTime?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePhotoBoothGameCategoryInput = {
  eventTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePhotoBoothGameTaskInput = {
  category?: InputMaybe<PhotoBoothGameCategoryByIdInput>;
  description?: InputMaybe<TranslationInput>;
  name?: InputMaybe<TranslationInput>;
  translateText?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePhotographer = {
  address?: InputMaybe<CreateAddress>;
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  contactFirstname?: InputMaybe<Scalars['String']['input']>;
  contactLastname?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disableInquiry?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  maximumTravelDistance?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  premiumUntil?: InputMaybe<Scalars['DateTime']['input']>;
  pricePerHour?: InputMaybe<Scalars['Int']['input']>;
  pricePerKilometer?: InputMaybe<Scalars['Int']['input']>;
  showOnlyForAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
  vimeo?: InputMaybe<Scalars['String']['input']>;
  weeksForImageEditing?: InputMaybe<Scalars['Int']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceVoucherInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  bookingDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  bookingDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<CreateServiceVoucherConfiguration>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowedOnAdditionalCarts?: InputMaybe<Scalars['Boolean']['input']>;
  isUpgradeVoucher?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfMaxUsages?: InputMaybe<Scalars['Int']['input']>;
  products?: InputMaybe<Array<InputMaybe<ServiceVoucherProductInput>>>;
  services?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successor?: InputMaybe<ServiceVoucherByCodeRefInput>;
  translations?: InputMaybe<ServiceVoucherTranslationsInput>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
  voucherType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  appCity?: InputMaybe<Scalars['String']['input']>;
  appCountry?: InputMaybe<Scalars['String']['input']>;
  appLatitude?: InputMaybe<Scalars['Float']['input']>;
  appLongitude?: InputMaybe<Scalars['Float']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  firstname: Scalars['String']['input'];
  language: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  market?: InputMaybe<MarketInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  smallBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWeddingFair = {
  address?: InputMaybe<CreateAddress>;
  area?: InputMaybe<Scalars['Float']['input']>;
  contactFirstname?: InputMaybe<Scalars['String']['input']>;
  contactLastname?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disableInquiry?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notTakingPlace?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfSuppliers?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  premiumUntil?: InputMaybe<Scalars['DateTime']['input']>;
  showOnlyForAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  telefax?: InputMaybe<Scalars['String']['input']>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketVVK?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
  vimeo?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type TranslationFragmentFragment = { __typename?: 'Translation', de?: string | null, en?: string | null, da?: string | null, fr?: string | null, nl?: string | null, pl?: string | null, it?: string | null, es?: string | null } & { ' $fragmentName'?: 'TranslationFragmentFragment' };

export type ServiceVoucherTranslatableFragmentFragment = { __typename?: 'ServiceVoucherTranslatable', name?: string | null, description?: string | null } & { ' $fragmentName'?: 'ServiceVoucherTranslatableFragmentFragment' };

export type MarketFieldsFragment = { __typename?: 'Market', availableServices: Array<string>, phone?: string | null, showInMarketSelect: boolean, key: string, keyLower: string, isMarketingActive?: boolean | null, phoneCompact: string, internationalDiallingCode?: string | null, email?: string | null, currency: string, dateFormat: string, preferredLanguage?: string | null, hasOffice: boolean, officeStreet1?: string | null, officeStreet2?: string | null, officeZip?: string | null, officeCity?: string | null, officeLatitude?: number | null, officeLongitude?: number | null, islandStates: Array<string>, languages: Array<string>, hasServiceProviderSearch: boolean, name: { __typename?: 'Translation', de?: string | null, en?: string | null, da?: string | null, fr?: string | null, nl?: string | null, pl?: string | null, it?: string | null, es?: string | null }, isLandStates: Array<{ __typename?: 'State', key: string, name: { __typename?: 'Translation', de?: string | null, en?: string | null, da?: string | null, fr?: string | null, nl?: string | null, pl?: string | null, it?: string | null, es?: string | null } }>, forbiddenStates: Array<{ __typename?: 'State', key: string, name: { __typename?: 'Translation', de?: string | null, en?: string | null, da?: string | null, fr?: string | null, nl?: string | null, pl?: string | null, it?: string | null, es?: string | null } }>, textReplacements: Array<{ __typename?: 'TextReplacement', text: string, replacement: string }>, paymentMethods?: { __typename?: 'AvailablePaymentMethods', primary: Array<string>, secondary: Array<string> } | null } & { ' $fragmentName'?: 'MarketFieldsFragment' };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id?: string | null, firstname?: string | null, lastname?: string | null, language?: string | null } | null };

export type LoginMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', tokenLogin?: { __typename?: 'UserRegistration', token: string } | null };

export type RequestAutoLoginTokenMutationVariables = Exact<{
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
}>;


export type RequestAutoLoginTokenMutation = { __typename?: 'Mutation', requestAutoLoginToken?: string | null };

export type GetPhotoboothGameCategoriesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPhotoboothGameCategoriesQuery = { __typename?: 'Query', photoBoothGameCategories: { __typename?: 'PorpaginasResult_PhotoBoothGameCategory', count?: number | null, items: Array<{ __typename?: 'PhotoBoothGameCategory', id?: string | null, uuid?: string | null, internalName?: string | null, eventTypes: Array<string> }> } };

export type CreatePhotoBoothGameCategoryMutationVariables = Exact<{
  newCategory?: InputMaybe<CreatePhotoBoothGameCategoryInput>;
}>;


export type CreatePhotoBoothGameCategoryMutation = { __typename?: 'Mutation', createPhotoBoothGameCategory: { __typename?: 'PhotoBoothGameCategory', uuid?: string | null, internalName?: string | null, eventTypes: Array<string> } };

export type DeletePhotoBoothGameCategoryMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeletePhotoBoothGameCategoryMutation = { __typename?: 'Mutation', deletePhotoBoothGameCategory?: string | null };

export type UpdatePhotoBoothGameCategoryMutationVariables = Exact<{
  category: PhotoBoothGameCategoryByIdInput;
  photoBoothGameCategoryInput: UpdatePhotoBoothGameCategoryInput;
}>;


export type UpdatePhotoBoothGameCategoryMutation = { __typename?: 'Mutation', updatePhotoBoothGameCategory: { __typename?: 'PhotoBoothGameCategory', uuid?: string | null, internalName?: string | null, eventTypes: Array<string> } };

export type CreatePhotoBoothGameTaskMutationVariables = Exact<{
  newTask: CreatePhotoBoothGameTaskInput;
}>;


export type CreatePhotoBoothGameTaskMutation = { __typename?: 'Mutation', createPhotoBoothGameTask: { __typename?: 'PhotoBoothGameTask', uuid: string, name: (
      { __typename?: 'Translation' }
      & { ' $fragmentRefs'?: { 'TranslationFragmentFragment': TranslationFragmentFragment } }
    ), description?: (
      { __typename?: 'Translation' }
      & { ' $fragmentRefs'?: { 'TranslationFragmentFragment': TranslationFragmentFragment } }
    ) | null, category: { __typename?: 'PhotoBoothGameCategory', uuid?: string | null } } };

export type UpdatePhotoBoothGameTaskMutationVariables = Exact<{
  taskPayload: UpdatePhotoBoothGameTaskInput;
  uuid: Scalars['String']['input'];
}>;


export type UpdatePhotoBoothGameTaskMutation = { __typename?: 'Mutation', updatePhotoBoothGameTask: { __typename?: 'PhotoBoothGameTask', uuid: string, name: (
      { __typename?: 'Translation' }
      & { ' $fragmentRefs'?: { 'TranslationFragmentFragment': TranslationFragmentFragment } }
    ), description?: (
      { __typename?: 'Translation' }
      & { ' $fragmentRefs'?: { 'TranslationFragmentFragment': TranslationFragmentFragment } }
    ) | null, category: { __typename?: 'PhotoBoothGameCategory', uuid?: string | null } } };

export type DeletePhotoBoothGameTaskMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeletePhotoBoothGameTaskMutation = { __typename?: 'Mutation', deletePhotoBoothGameTask?: string | null };

export type GetPhotoboothGamesTasksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<PhotoBoothGameCategoryByIdInput>;
  eventType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPhotoboothGamesTasksQuery = { __typename?: 'Query', photoBoothGameTasks: { __typename?: 'PorpaginasResult_PhotoBoothGameTask', count?: number | null, items: Array<{ __typename?: 'PhotoBoothGameTask', uuid: string, name: (
        { __typename?: 'Translation' }
        & { ' $fragmentRefs'?: { 'TranslationFragmentFragment': TranslationFragmentFragment } }
      ), description?: (
        { __typename?: 'Translation' }
        & { ' $fragmentRefs'?: { 'TranslationFragmentFragment': TranslationFragmentFragment } }
      ) | null, category: { __typename?: 'PhotoBoothGameCategory', uuid?: string | null } }> } };

export type GetKeyValuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKeyValuesQuery = { __typename?: 'Query', listKeyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> };

export type UpdateKeyValueMutationVariables = Exact<{
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
}>;


export type UpdateKeyValueMutation = { __typename?: 'Mutation', updateKeyValue: { __typename?: 'KeyValue', key: string, value: string } };

export type ServiceVouchersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ServiceVoucherSearchInput>;
}>;


export type ServiceVouchersQuery = { __typename?: 'Query', serviceVouchers: { __typename?: 'PorpaginasResult_ServiceVoucher', count?: number | null, items: Array<{ __typename?: 'ServiceVoucher', id: string, code: string, isActive: boolean, services: Array<string>, amount: number, validFrom: any, validTo: any, voucherType?: string | null, numberOfUsages: number, numberOfMaxUsages: number, valueType?: string | null, bookingDateFrom?: any | null, bookingDateTo?: any | null, translations: { __typename?: 'ServiceVoucherTranslation', de?: (
          { __typename?: 'ServiceVoucherTranslatable' }
          & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
        ) | null, en?: (
          { __typename?: 'ServiceVoucherTranslatable' }
          & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
        ) | null, fr?: (
          { __typename?: 'ServiceVoucherTranslatable' }
          & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
        ) | null, nl?: (
          { __typename?: 'ServiceVoucherTranslatable' }
          & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
        ) | null, da?: (
          { __typename?: 'ServiceVoucherTranslatable' }
          & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
        ) | null, pl?: (
          { __typename?: 'ServiceVoucherTranslatable' }
          & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
        ) | null, it?: (
          { __typename?: 'ServiceVoucherTranslatable' }
          & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
        ) | null, es?: (
          { __typename?: 'ServiceVoucherTranslatable' }
          & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
        ) | null }, configuration: { __typename?: 'ServiceVoucherConfiguration', isAbleToMarkCartAsPaid: boolean, markets: { __typename?: 'MarketActivation', DE?: boolean | null, AT?: boolean | null, FR?: boolean | null, BE?: boolean | null, NL?: boolean | null, LU?: boolean | null, DK?: boolean | null, PL?: boolean | null, IT?: boolean | null, ES?: boolean | null, CH?: boolean | null, GB?: boolean | null, US?: boolean | null } }, products?: Array<{ __typename?: 'ServiceVoucherProduct', amount: number, productId: number } | null> | null }> } };

export type UpdateServiceVoucherMutationVariables = Exact<{
  serviceVoucher: UpdateServiceVoucherInput;
}>;


export type UpdateServiceVoucherMutation = { __typename?: 'Mutation', updateServiceVoucher: { __typename?: 'ServiceVoucher', id: string, code: string, isActive: boolean, services: Array<string>, amount: number, validFrom: any, validTo: any, bookingDateFrom?: any | null, bookingDateTo?: any | null, voucherType?: string | null, numberOfUsages: number, numberOfMaxUsages: number, valueType?: string | null, translations: { __typename?: 'ServiceVoucherTranslation', de?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null, en?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null, fr?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null, nl?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null, da?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null, pl?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null, it?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null, es?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null }, configuration: { __typename?: 'ServiceVoucherConfiguration', isAbleToMarkCartAsPaid: boolean, markets: { __typename?: 'MarketActivation', DE?: boolean | null, AT?: boolean | null, FR?: boolean | null, BE?: boolean | null, NL?: boolean | null, LU?: boolean | null, DK?: boolean | null, PL?: boolean | null, IT?: boolean | null, ES?: boolean | null, CH?: boolean | null, GB?: boolean | null, US?: boolean | null } }, products?: Array<{ __typename?: 'ServiceVoucherProduct', amount: number, productId: number } | null> | null } };

export type CreateServiceVoucherMutationVariables = Exact<{
  serviceVoucher: CreateServiceVoucherInput;
}>;


export type CreateServiceVoucherMutation = { __typename?: 'Mutation', createServiceVoucher: { __typename?: 'ServiceVoucher', id: string, code: string, isActive: boolean, services: Array<string>, amount: number, validFrom: any, validTo: any, bookingDateFrom?: any | null, bookingDateTo?: any | null, voucherType?: string | null, numberOfUsages: number, numberOfMaxUsages: number, valueType?: string | null, translations: { __typename?: 'ServiceVoucherTranslation', de?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null, en?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null, fr?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null, nl?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null, da?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null, pl?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null, it?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null, es?: (
        { __typename?: 'ServiceVoucherTranslatable' }
        & { ' $fragmentRefs'?: { 'ServiceVoucherTranslatableFragmentFragment': ServiceVoucherTranslatableFragmentFragment } }
      ) | null }, configuration: { __typename?: 'ServiceVoucherConfiguration', isAbleToMarkCartAsPaid: boolean, markets: { __typename?: 'MarketActivation', DE?: boolean | null, AT?: boolean | null, FR?: boolean | null, BE?: boolean | null, NL?: boolean | null, LU?: boolean | null, DK?: boolean | null, PL?: boolean | null, IT?: boolean | null, ES?: boolean | null, CH?: boolean | null, GB?: boolean | null, US?: boolean | null } }, products?: Array<{ __typename?: 'ServiceVoucherProduct', amount: number, productId: number } | null> | null } };

export const TranslationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Translation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"de"}},{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"da"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"nl"}},{"kind":"Field","name":{"kind":"Name","value":"pl"}},{"kind":"Field","name":{"kind":"Name","value":"it"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<TranslationFragmentFragment, unknown>;
export const ServiceVoucherTranslatableFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceVoucherTranslatable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<ServiceVoucherTranslatableFragmentFragment, unknown>;
export const MarketFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Market"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableServices"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"showInMarketSelect"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"de"}},{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"da"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"nl"}},{"kind":"Field","name":{"kind":"Name","value":"pl"}},{"kind":"Field","name":{"kind":"Name","value":"it"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isLandStates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"de"}},{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"da"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"nl"}},{"kind":"Field","name":{"kind":"Name","value":"pl"}},{"kind":"Field","name":{"kind":"Name","value":"it"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"forbiddenStates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"de"}},{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"da"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"nl"}},{"kind":"Field","name":{"kind":"Name","value":"pl"}},{"kind":"Field","name":{"kind":"Name","value":"it"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"textReplacements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"replacement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"keyLower"}},{"kind":"Field","name":{"kind":"Name","value":"isMarketingActive"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCompact"}},{"kind":"Field","name":{"kind":"Name","value":"internationalDiallingCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"preferredLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"hasOffice"}},{"kind":"Field","name":{"kind":"Name","value":"officeStreet1"}},{"kind":"Field","name":{"kind":"Name","value":"officeStreet2"}},{"kind":"Field","name":{"kind":"Name","value":"officeZip"}},{"kind":"Field","name":{"kind":"Name","value":"officeCity"}},{"kind":"Field","name":{"kind":"Name","value":"officeLatitude"}},{"kind":"Field","name":{"kind":"Name","value":"officeLongitude"}},{"kind":"Field","name":{"kind":"Name","value":"islandStates"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"secondary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasServiceProviderSearch"}}]}}]} as unknown as DocumentNode<MarketFieldsFragment, unknown>;
export const GetCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const RequestAutoLoginTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"requestAutoLoginToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestAutoLoginToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirectUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"StringValue","value":"admin","block":false}}]}]}}]} as unknown as DocumentNode<RequestAutoLoginTokenMutation, RequestAutoLoginTokenMutationVariables>;
export const GetPhotoboothGameCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPhotoboothGameCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoBoothGameCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"eventTypes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<GetPhotoboothGameCategoriesQuery, GetPhotoboothGameCategoriesQueryVariables>;
export const CreatePhotoBoothGameCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPhotoBoothGameCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newCategory"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"createPhotoBoothGameCategoryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPhotoBoothGameCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"photoBoothGameCategoryInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newCategory"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"eventTypes"}}]}}]}}]} as unknown as DocumentNode<CreatePhotoBoothGameCategoryMutation, CreatePhotoBoothGameCategoryMutationVariables>;
export const DeletePhotoBoothGameCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePhotoBoothGameCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePhotoBoothGameCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}]}}]}]}}]} as unknown as DocumentNode<DeletePhotoBoothGameCategoryMutation, DeletePhotoBoothGameCategoryMutationVariables>;
export const UpdatePhotoBoothGameCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePhotoBoothGameCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoBoothGameCategoryByIdInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photoBoothGameCategoryInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updatePhotoBoothGameCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePhotoBoothGameCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"photoBoothGameCategoryInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photoBoothGameCategoryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"eventTypes"}}]}}]}}]} as unknown as DocumentNode<UpdatePhotoBoothGameCategoryMutation, UpdatePhotoBoothGameCategoryMutationVariables>;
export const CreatePhotoBoothGameTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPhotoBoothGameTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newTask"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"createPhotoBoothGameTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPhotoBoothGameTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"photoBoothGameTaskInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newTask"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Translation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"de"}},{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"da"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"nl"}},{"kind":"Field","name":{"kind":"Name","value":"pl"}},{"kind":"Field","name":{"kind":"Name","value":"it"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<CreatePhotoBoothGameTaskMutation, CreatePhotoBoothGameTaskMutationVariables>;
export const UpdatePhotoBoothGameTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePhotoBoothGameTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskPayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updatePhotoBoothGameTaskInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePhotoBoothGameTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"photoBoothGameTaskInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskPayload"}}},{"kind":"Argument","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Translation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"de"}},{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"da"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"nl"}},{"kind":"Field","name":{"kind":"Name","value":"pl"}},{"kind":"Field","name":{"kind":"Name","value":"it"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<UpdatePhotoBoothGameTaskMutation, UpdatePhotoBoothGameTaskMutationVariables>;
export const DeletePhotoBoothGameTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePhotoBoothGameTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePhotoBoothGameTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}]}}]}]}}]} as unknown as DocumentNode<DeletePhotoBoothGameTaskMutation, DeletePhotoBoothGameTaskMutationVariables>;
export const GetPhotoboothGamesTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPhotoboothGamesTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoBoothGameCategoryByIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoBoothGameTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"StringValue","value":"active","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"eventType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventType"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Translation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"de"}},{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"da"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"nl"}},{"kind":"Field","name":{"kind":"Name","value":"pl"}},{"kind":"Field","name":{"kind":"Name","value":"it"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<GetPhotoboothGamesTasksQuery, GetPhotoboothGamesTasksQueryVariables>;
export const GetKeyValuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getKeyValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listKeyValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetKeyValuesQuery, GetKeyValuesQueryVariables>;
export const UpdateKeyValueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateKeyValue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateKeyValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"Argument","name":{"kind":"Name","value":"encodedValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpdateKeyValueMutation, UpdateKeyValueMutationVariables>;
export const ServiceVouchersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ServiceVouchers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceVoucherSearchInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceVouchers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"de"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"da"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"it"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"es"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"voucherType"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfUsages"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfMaxUsages"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DE"}},{"kind":"Field","name":{"kind":"Name","value":"AT"}},{"kind":"Field","name":{"kind":"Name","value":"FR"}},{"kind":"Field","name":{"kind":"Name","value":"BE"}},{"kind":"Field","name":{"kind":"Name","value":"NL"}},{"kind":"Field","name":{"kind":"Name","value":"LU"}},{"kind":"Field","name":{"kind":"Name","value":"DK"}},{"kind":"Field","name":{"kind":"Name","value":"PL"}},{"kind":"Field","name":{"kind":"Name","value":"IT"}},{"kind":"Field","name":{"kind":"Name","value":"ES"}},{"kind":"Field","name":{"kind":"Name","value":"CH"}},{"kind":"Field","name":{"kind":"Name","value":"GB"}},{"kind":"Field","name":{"kind":"Name","value":"US"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAbleToMarkCartAsPaid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookingDateFrom"}},{"kind":"Field","name":{"kind":"Name","value":"bookingDateTo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceVoucherTranslatable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<ServiceVouchersQuery, ServiceVouchersQueryVariables>;
export const UpdateServiceVoucherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateServiceVoucher"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceVoucher"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateServiceVoucherInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateServiceVoucher"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"serviceVoucher"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceVoucher"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"de"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"da"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"it"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"es"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"bookingDateFrom"}},{"kind":"Field","name":{"kind":"Name","value":"bookingDateTo"}},{"kind":"Field","name":{"kind":"Name","value":"voucherType"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfUsages"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfMaxUsages"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DE"}},{"kind":"Field","name":{"kind":"Name","value":"AT"}},{"kind":"Field","name":{"kind":"Name","value":"FR"}},{"kind":"Field","name":{"kind":"Name","value":"BE"}},{"kind":"Field","name":{"kind":"Name","value":"NL"}},{"kind":"Field","name":{"kind":"Name","value":"LU"}},{"kind":"Field","name":{"kind":"Name","value":"DK"}},{"kind":"Field","name":{"kind":"Name","value":"PL"}},{"kind":"Field","name":{"kind":"Name","value":"IT"}},{"kind":"Field","name":{"kind":"Name","value":"ES"}},{"kind":"Field","name":{"kind":"Name","value":"CH"}},{"kind":"Field","name":{"kind":"Name","value":"GB"}},{"kind":"Field","name":{"kind":"Name","value":"US"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAbleToMarkCartAsPaid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceVoucherTranslatable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<UpdateServiceVoucherMutation, UpdateServiceVoucherMutationVariables>;
export const CreateServiceVoucherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateServiceVoucher"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceVoucher"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"createServiceVoucherInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createServiceVoucher"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"serviceVoucher"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceVoucher"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"de"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"en"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"da"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"it"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"es"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"bookingDateFrom"}},{"kind":"Field","name":{"kind":"Name","value":"bookingDateTo"}},{"kind":"Field","name":{"kind":"Name","value":"voucherType"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfUsages"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfMaxUsages"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DE"}},{"kind":"Field","name":{"kind":"Name","value":"AT"}},{"kind":"Field","name":{"kind":"Name","value":"FR"}},{"kind":"Field","name":{"kind":"Name","value":"BE"}},{"kind":"Field","name":{"kind":"Name","value":"NL"}},{"kind":"Field","name":{"kind":"Name","value":"LU"}},{"kind":"Field","name":{"kind":"Name","value":"DK"}},{"kind":"Field","name":{"kind":"Name","value":"PL"}},{"kind":"Field","name":{"kind":"Name","value":"IT"}},{"kind":"Field","name":{"kind":"Name","value":"ES"}},{"kind":"Field","name":{"kind":"Name","value":"CH"}},{"kind":"Field","name":{"kind":"Name","value":"GB"}},{"kind":"Field","name":{"kind":"Name","value":"US"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAbleToMarkCartAsPaid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceVoucherTranslatableFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceVoucherTranslatable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<CreateServiceVoucherMutation, CreateServiceVoucherMutationVariables>;